<template>
  <div :class="colorMode" id="main-FreetextElem">


    <div :class="['floating-menu', { 'non-full-freetext': !isFullScreen }, { 'full-freetext': isFullScreen }]"
      v-if="isShowFloatingOptions">
      <div class="floating-icons">
        <a id="mark-completed" @click="markCompleted(!isCompleted)"
          :class="'float-icon completed-icon ' + (isCompleted ? 'active' : '')">
          <i v-if="!(actionsLoading.markcompleted)"
            :class="isCompleted ? 'fa fa-lg fa-check-circle' : 'far fa-lg fa-check-circle'"
            :style="{ color: isCompleted ? 'green' : 'black' }"></i>
          <i v-else class="fa fa-spinner fa-spin" :style="{ color: 'black', fontSize: '18px' }"></i>
        </a>

        <b-dropdown id="rating" ref="ratingDropdown" class="p-0 pt-1 float-icon" size="lg" variant="link"
          toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i v-if="!(actionsLoading.rating)" :class="starClass" :style="starStyle"></i>
            <i v-if="(actionsLoading.rating)" class="fa fa-spinner fa-spin" style="color:black; font-size:18px"></i>
          </template>

          <b-dropdown-form v-if="!(actionsLoading.rating)" style="width: 150px;">
           <div v-if="currentRating !== 'unrated'">
              <input class="form-check-input high" type="radio" name="confidenceBtn" :checked="currentRating === 'unrated'"
                id="confidenceBtn0" value="high" @click="setConfidenceLevel('Unrated')" style="display: none;">
              <label class="confidence-btn btn-high" for="confidenceBtn0">
                <i class="fa fa-star-o" style="color: black"></i> Unrated
              </label>
            </div>
            <div>
              <input class="form-check-input high" type="radio" name="confidenceBtn" :checked="currentRating === 'high'"
                id="confidenceBtn1" value="high" @click="setConfidenceLevel('High')" style="display: none;">
              <label class="confidence-btn btn-high" for="confidenceBtn1">
                <i class="fa fa-star" style="color: green;"></i> High
              </label>
            </div>
            <div>
              <input class="form-check-input medium" type="radio" name="confidenceBtn"
                :checked="currentRating === 'medium'" id="confidenceBtn2" value="medium"
                @click="setConfidenceLevel('Medium')" style="display: none;">
              <label class="confidence-btn btn-medium" for="confidenceBtn2">
                <i class="fa fa-star" style="color: yellow;"></i> Medium
              </label>
            </div>
            <div>
              <input class="form-check-input low" type="radio" name="confidenceBtn" :checked="currentRating === 'low'"
                id="confidenceBtn3" value="low" @click="setConfidenceLevel('Low')" style="display: none;">
              <label class="confidence-btn btn-low" for="confidenceBtn3">
                <i class="fa fa-star" style="color: red;"></i> Low
              </label>
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <a id="bookmark" @click="manageBookmark" 
        :class="' float-icon bookmark-icon ' + (isFreetextBookmarked ? 'active' : '') + (!isAnyTextSeleCted && !isFreetextBookmarked ? ' disabled' : '')">
          <i v-if="!(actionsLoading.bookmark)"
            :class="'fa fa-lg ' + (isFreetextBookmarked ? ' fa-bookmark' : ' fa-bookmark-o')"></i>
          <i v-else class="fa fa-spinner fa-spin" :style="{ color: 'black', fontSize: '18px' }"></i>
        </a>

        <!-- Working content Bookmark  -->
        <!-- <a id="bookmark" @click="setBookmark" :class="'float-icon bookmark-icon ' + (isBookmarked ? 'active' : '')">
          <i v-if="!(actionsLoading.bookmark)"
            :class="'fa fa-lg ' + (isBookmarked ? ' fa-bookmark' : ' fa-bookmark-o')"></i>
          <i v-else class="fa fa-spinner fa-spin" :style="{ color: 'black', fontSize: '18px' }"></i>
        </a> -->

        <!-- <a  href="#"  class="float-icon edit-icon">
          <img src="../../../assets/images/edit-icon.svg">
        </a> -->

        <!-- <a @click="highlight" :class="(!isAnyTextSeleCted ? 'disabled' : '') + ' float-icon highlight-icon'"
          :disabled="!isAnyTextSeleCted" href="#">
          <img src="../../../assets/images/brush-icon.svg">
        </a> -->

        <b-tooltip target="mark-completed" triggers="hover">{{ isCompleted ? 'Mark Uncomplete' : 'Mark Complete'}}</b-tooltip>
        <b-tooltip target="rating" triggers="hover">Rating</b-tooltip>
        <b-tooltip target="bookmark" triggers="hover">Bookmark</b-tooltip>
        <b-tooltip target="highlight" triggers="hover">Highlight</b-tooltip>
        <b-tooltip target="notes-list-tooltip" triggers="hover">Notes</b-tooltip>
        <b-tooltip target="highlightlist" triggers="hover">Highlights</b-tooltip>
        <b-tooltip target="freetext-search" triggers="hover">Search</b-tooltip>
        <b-tooltip target="note" triggers="hover">Note</b-tooltip>
        <b-tooltip target="speak" triggers="hover">Speak</b-tooltip>
        <b-tooltip target="margin" triggers="hover">Margin</b-tooltip>
        <b-tooltip target="stopspeak" triggers="hover">Stop Speak</b-tooltip>
        <b-tooltip target="List" triggers="hover">Lists</b-tooltip>
        <b-tooltip target="font-family" triggers="hover">Font Family</b-tooltip>
        <b-tooltip target="textheight" triggers="hover">Text Height</b-tooltip>
        <b-tooltip target="lineheight" triggers="hover">Line Height</b-tooltip>
        <b-tooltip target="textalign" triggers="hover">Text Align</b-tooltip>
        <b-tooltip target="colorMode" triggers="hover">Color Mode</b-tooltip>
        <b-tooltip target="fullscreen" triggers="hover">Fullscreen</b-tooltip>
        <b-tooltip target="exitFullscreen" triggers="hover">Exit Fullscreen</b-tooltip>
        <b-dropdown 
          :class="(!isAnyTextSeleCted ? 'disabled' : '') + ' float-icon highlight-icon'" id="highlight"
          ref="highlightDropdown"
          :disabled="!highlightedSelectedId && !isAnyTextSeleCted" size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <img id="highlight" src="../../../assets/images/brush-icon.svg">
          </template>
          <b-dropdown-form style="width: 300px;">
            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Highlight</b></label>
            </div>
            <div style="display: flex;">
              <a v-for="color in highlightColors" :key="color" href="#" @click="manageHighlight(color)"
                :style="{ flex: 1, marginRight: '10px', backgroundColor: color }" class="float-icon">
                <i v-if="selectedHighlightColor === color" id="unhighlight"
                  :style="{ fontSize: '20px', color: 'black' }" class="fa fa-trash toolbox-icon"></i>
              </a>
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <!-- <a href="#" id="unhighlight" v-if="highlightedSelectedId" @click="unhighlight"
          :class="(!isAnyTextSeleCted ? 'disabled' : '') + ' float-icon highlight-icon'" :disabled="isAnyTextSeleCted">
          <i id="unhighlight"  :style="{ fontSize: '15px' }" class="fa fa-trash toolbox-icon"></i>
        </a> -->

        <a @click="takeNotes" id="note" :class="(!isAnyTextSeleCted ? 'disabled' : '') + ' float-icon note-icon'"
          :disabled="!isAnyTextSeleCted" href="#">
          <img src="../../../assets/images/edit-alt-icon.svg">
        </a>

        <b-dropdown
          ref="freetextSearchDrpdown"
          :class="'float-icon highlight-icon'"
          id="freetext-search"
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          @hide="onEditControlMenuHide"
          no-caret
        >
          <template #button-content>
            <i
              id="freetext-search"
              class="fa fa-search"
              @click="toggleSearch"
            ></i>
          </template>

            <div style="width:350px; display: flex; justify-content: space-between; align-items: center; margin: 0px 10px;">
              <input 
                id="content-search"
                ref="contentSearchInput"
                type="text" 
                class="form-control" 
                placeholder="Enter search term"
                maxlength="100"
                style="flex: 3; height: 2rem; border-radius: 5px; margin-top: 8px"
                @keyup.enter="doSearch"
                v-model="contentSearch"
              />
              <!-- @input="handleInput" -->
              <small class="form-text text-muted character-counter" style="margin-left: 1rem;"> {{ searchIndex > -1 ? searchIndex + 1 : 0 }} / {{ searchResults.length }} </small>
              <button type="button" @click="doSearch" class="btn btn-outline-secondary btn-sm" style="height: 2rem; margin-left: 1rem;"><i class="fa fa-search"></i></button>
              <button type="button" @click="previousSearchResult" class="btn btn-outline-secondary btn-sm" style="height: 2rem; margin-left: 1rem;"><i class="fa fa-caret-left"></i></button>
              <button type="button" @click="nextSearchResult" class="btn btn-outline-secondary btn-sm" style="margin-left:10px; height: 2rem;"><i class="fa fa-caret-right"></i></button>
              <button type="button" @click="closeSearch"
               class="btn btn-sm" style="margin-left:10px; height: 2rem;"><i class="fa fa-close"></i></button>
            </div>

        </b-dropdown>


        <a href="#"
          id="speak"
          v-if="(!speechSynthesis || !speechSynthesis.speaking)"
          @click="()=> {
            if(isAnyTextSeleCted) playSelected()
          }"
          :class="['float-icon note-icon', { 'disabled': !isAnyTextSeleCted }]"
          :disabled="!isAnyTextSeleCted"
        >
          <i id="speak" class="fas fa-volume-up"></i>
      </a>


        <a href="#" id="stopspeak" class="float-icon note-icon" v-if="speechSynthesis && speechSynthesis.speaking"
          @click="() => { speechSynthesis.cancel(); speechSynthesis = null;  
            ePubEditor.speechMarker.classAppliers.speechHighlight.undoToRanges([speechWords[speechWordIndex].range]);}">
          <i id="stopspeak" class="fas fa-stop"></i>
        </a>

        <a href="#" v-if="isAIHelpEnabled" @click="getAIHelp" class="float-icon ai-icon">
          <img src="../../../assets/images/artificial-intelligence-ai-icon.svg">
        </a>

        <b-dropdown id="font-family" :disabled="isAnyTextSeleCted"
            :class="['p-0', 'pt-1', 'float-icon', 'calculator-icon', { 'disabled': isAnyTextSeleCted }]"
            size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <i id="font-family-button" class="fas fa-font"></i>
        </template>

        <b-dropdown-menu style="display:block; width: 300px; padding: 10px">
          <div style="display: flex; ">
              <label style="flex: 1;" class="mr-3"><b>Font Family</b></label>
          </div>
          <select  v-model="currentFontFamily" :disabled="isAnyTextSeleCted" class="form-select form-select-lg">
          <option v-for="(font, index) in fontFamilies" :key="index" :value="font.value">
            {{ font.label }}
          </option>
        </select>
        </b-dropdown-menu>
      </b-dropdown>




        <b-dropdown id="textheight" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'float-icon-textheight', 'calculator-icon', { 'disabled': isAnyTextSeleCted }]"
          size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i class="fas fa-text-height"></i>
          </template>
          
          <b-dropdown-form style="width: 300px;">
            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Text Size</b></label>
              <a href="#" @click="setDefaultFontSize">Reset</a>
            </div>
            <div class="text-size-controls">
              <button type="button" @click="decreaseFontSize" class="btn btn-outline-primary btn-sm">-</button>
              <label>{{ currentFontSizePercent }}%</label>
              <button type="button" @click="increaseFontSize" class="btn btn-outline-primary btn-sm">+</button>
            </div>
            <!--            <b-form-input id="currentFontSizePercent-range" v-model="currentFontSizePercent" type="range" min="-40"
              max="100"></b-form-input>-->
          </b-dropdown-form>
        </b-dropdown>


        <b-dropdown id="lineheight" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'calculator-icon', 'float-icon-lineheight', { 'disabled': isAnyTextSeleCted }]"
          size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i class="fas fa-line-height"></i>
          </template>
          <b-dropdown-form style="width: 240px;">

            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Line Height</b></label>
              <a href="#" @click="() => { currentLineHeightPercent = 0; }">Reset</a>
            </div>
            <b-form-input id="currentLineHeightPercent-range" v-model="currentLineHeightPercent" type="range" min="-20"
              max="50"></b-form-input>
          </b-dropdown-form>
        </b-dropdown>

        <b-dropdown id="textalign" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'float-icon-textalign', 'calculator-icon', { 'disabled': isAnyTextSeleCted }]"
          size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i class="fas fa-align-justify"></i>
          </template>
          <b-dropdown-form style="width: 200px;">
            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Align</b></label>
            </div>
            <div style="display: flex;">
              <a href="#" @click="setTextAlign('left')" style="flex: 1; margin-right: 10px;"
                class="float-icon calculator-icon mr-2">
                <i class="fas fa-align-left"></i>
              </a>
              <a href="#" @click="setTextAlign('right')" style="flex: 1; margin-right: 10px"
                class="float-icon calculator-icon mr-2">
                <i class="fas fa-align-right"></i>
              </a>
              <a href="#" @click="setTextAlign('center')" style="flex: 1; margin-right: 10px"
                class="float-icon calculator-icon mr-2">
                <i class="fas fa-align-center"></i>
              </a>
              <a href="#" @click="setTextAlign('justify')" style="flex: 1;" class="float-icon calculator-icon">
                <i class="fas fa-align-justify"></i>
              </a>
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <!-- <b-dropdown id="margin" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'calculator-icon', { 'disabled': isAnyTextSeleCted }]" size="lg"
          variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i class="fas fa-expand"></i>
          </template>
          <b-dropdown-form style="width: 300px;">
            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Page Margin</b></label>
              <a href="#" @click="() => { currentMargin = 50; }">Reset</a>
            </div>
            <b-form-input id="currentMargin-range" v-model="currentMargin" type="range" min="0" max="100"></b-form-input>
          </b-dropdown-form>
        </b-dropdown> -->

        <b-dropdown id="colorMode" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'calculator-icon', colorMode, { 'disabled': isAnyTextSeleCted }]"
          size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i v-if="colorMode == 'light'" class="fas fa-lightbulb"></i>
            <i v-if="colorMode == 'custom-dark'" class="fas fa-moon"></i>
            <i v-if="colorMode == 'sepia'" class="fas fa-eye"></i>
          </template>
          <b-dropdown-form style="width: 220px;">
            <div style="display: flex;">
              <label style="flex: 1;" class="mr-3"><b>Mode</b></label>
            </div>
            <div style="display: flex;">
              <a href="#" @click="setdefaultMode" style="flex: 1; margin-right: 10px;" class="float-icon">
                Light
              </a>
              <a href="#" @click="setMode('custom-dark')" style="flex: 1; margin-right: 10px;"
                class="float-icon  custom-dark text-white">
                Dark
              </a>
              <a href="#" @click="setMode('sepia')"
                style="flex: 1; margin-right: 10px; background: rgb(255, 242, 208); color: rgb(139, 82, 32);"
                class="float-icon">
                Sepia
              </a>
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <b-dropdown id="List" :disabled="isAnyTextSeleCted"
          :class="['p-0', 'pt-1', 'float-icon', 'calculator-icon', { 'disabled': isAnyTextSeleCted }]"
          size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i id="notes-list-button" class="fas fa-tasks"></i>
          </template>
          <b-dropdown-form class="mt-2" style="width: 180px;">
            <div style="display: flex;">
              <a href="#" @click="() => { 
          isNotesListVisible = !isNotesListVisible;
          if(isOffcanvasOpen) isOffcanvasOpen = false;
          if(isHighlightsListVisible) isHighlightsListVisible = false;

          }"
              style="flex: 1; margin-right: 10px;" class="float-icon">
                Notes
              </a>
            </div>
            <div style="display: flex;">
              <a href="#" @click="() => { 
          isHighlightsListVisible = !isHighlightsListVisible;
          if(isOffcanvasOpen) isOffcanvasOpen = false;
          if(isNotesListVisible) isNotesListVisible = false;

          }" style="flex: 1; margin-right: 10px;" class="float-icon">
                Highlights
              </a>
              
            </div>
          </b-dropdown-form>
        </b-dropdown>

        <!-- <a @click="() => { 
          isNotesListVisible = !isNotesListVisible;
          if(isOffcanvasOpen) isOffcanvasOpen = false;
          if(isHighlightsListVisible) isHighlightsListVisible = false;

          }" id="notes-list-tooltip" :class="'float-icon note-icon'" href="#">
          <i id="notes-list-button" class="fas fa-tasks"></i>
        </a>

        <a @click="() => { 
          isHighlightsListVisible = !isHighlightsListVisible;
          if(isOffcanvasOpen) isOffcanvasOpen = false;
          if(isNotesListVisible) isNotesListVisible = false;

          }" id="highlightlist"
          :class="'float-icon highlight-icon'" href="#">
          <i id="highlights-list-button" class="fas fa-list"></i>
        </a> -->
        
        <!-- Speach check added to reduce elements in mobile  -->
        <a href="#" id="fullscreen" v-if="isFullscreenSupported() && !isFullScreen"
          :class="['float-icon', 'fullscreen-icon']" @click="makeFullscreen">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>

        <a href="#" id="exitFullscreen" v-if="isFullscreenSupported() && isFullScreen"
          :class="['float-icon', 'fullscreen-icon']" @click="exitFullscreen">
          <i class="fas fa-compress-arrows-alt"></i>
        </a>
        <!-- <a href="#" class="float-icon calculator-icon">
          <img src="../../../assets/images/calculator-icon.svg">
        </a> -->

      </div>
    </div>
    

    <Calculator :visible="this.showCalculator" @updateModalState="toggleCalculator" />
    <div class="freeText-main-content">
      <!-- <h1 class="main-heading">{{ contentData.title }}</h1> -->
      <b-sidebar id="my-sidebar" class="Ai-Sidebar" title="AI" :visible="isAIAssitantOpen" shadow right>
        <AIAssitant :url="getAIUrl" :prompt="currentPrompt" @onPrompt="getAIHelp"
          @onClose="() => { isAIAssitantOpen = false }" />
      </b-sidebar>


      <b-sidebar id="notes-list" class="notes-sidebar" :visible="isNotesListVisible" shadow right>
        <div class="header">
          <h2 class="modal-heading">Notes</h2>
          <button class="close-icon-button" @click="() => { isNotesListVisible = false }">
            <i class="fas fa-times"></i>
          </button>
        </div>


        <!-- Check if notesFromState is empty -->
        <div v-if="notes.length === 0" class="no-notes-message">
          <p>No notes available</p>
        </div>

        <!-- Display notes if available -->
        <div v-else class="notes-container">
          <div v-for="(note, index) in getSortedNotes" :key="index" class="note-wrapper">
            <div class="note-content" @click="onNotesContentView(note)">
              <p class="note-text">
                <i class="far fa-sticky-note note-icon"></i>
                {{ notesShowMore && notesShowMore[note.id] == true ? note.text : (note.text.substring(0, 150) + '...' )}}
                <!-- <button v-if="note.text.length > 150" @click="toggleNotesListShowMore(note)" class="btn btn-link">
                  {{  notesShowMore && notesShowMore[note.id] == true ? 'Show less' : 'Show more' }}
                </button> -->
              </p>
              <p class="comment-text" v-if="note.comment">
                {{ note.comment }}
              </p>
            </div>
            <div class="note-actions">
              <button class="eb-notes-view" @click="onNotesContentView(note)">
                <span>View</span>
              </button>
              <!-- <button class="eb-notes-delete" @click="removeSingleNote(note)">
                <span>Remove</span>
              </button> -->
            </div>
            <div>
              <hr/>
            </div>
          </div>
        </div>
      </b-sidebar>

      <b-sidebar id="highlights-list" class="highlights-sidebar" :visible="isHighlightsListVisible" shadow right>
        <div class="header">
          <h2 class="modal-heading">Highlights</h2>
          <button class="close-icon-button" @click="() => { isHighlightsListVisible = false }">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div v-if="highlightedRanges.length === 0" class="no-notes-message">
          <p>No highlights available</p>
        </div>

        <div v-else class="highlights-container">
          <div v-for="(highlight, index) in getSortedHighlights" :key="index" class="highlight-wrapper">
            <div class="highlight-content" @click="onHighlightContentView(highlight)">
              <p class="highlight-text" :style="`border-left-color:${highlight.color?highlight.color:'yellow'}`" >
                <span v-html="highlightsShowMore && highlightsShowMore[highlight.id] == true ? highlight.text : (highlight.text.substring(0, 150) + '...')"></span> 
                <!-- <button v-if="highlight.text.length > 150" @click="toggleHighlightsListShowMore(highlight)" class="btn btn-link">
                  {{ highlightsShowMore && highlightsShowMore[highlight.id] == true ? 'Show less' : 'Show more' }}
                </button>   -->
              </p>
            </div>
            <div class="note-actions">
              <button class="eb-notes-view" @click="onHighlightContentView(highlight)">
                <span>View</span>
              </button>
              <!-- <button class="eb-notes-delete" @click="removeSingleHighlight(highlight)">
                <span>Remove</span>
              </button> -->
            </div>
            <div>
              <hr/>
            </div>
          </div>
        </div>
      </b-sidebar>


      <div v-if="isQuillSupported" id="editor" v-html="contentData.data">
      </div>

      <iframe v-else id="html-Editor">
      </iframe>

      <b-sidebar id="my-sidebar" :visible="isOffcanvasOpen" shadow right>
        <div class="sidebar-content p-4">
          <div class="note-header">
            <h2 class="modal-heading">Notes</h2>
            <i v-if="selectedNoteIndex > -1" class="fas fa-trash-alt" @click="removeNote(selectedNoteIndex)"></i>
          </div>
          <div class="note-content">
            <div v-if="selectedNote.text">
              <p>
                {{ showMore ? selectedNote.text : truncatedText }}
                <button v-if="isOverflowing" @click="toggleShowMore" class="btn btn-link">
                  {{ showMore ? 'Show less' : 'Show more' }}
                </button>
              </p>
            </div>
            <div class="form-group">
              <textarea v-model="selectedNote.comment" placeholder="Write your comment" maxlength="1000"
                class="form-control notes-textarea"></textarea>
              <small class="form-text text-muted character-counter">
                {{ selectedNote.comment.length }} / 1000 characters
              </small>
            </div>
            <button @click="setComment(selectedNoteIndex, selectedNote.comment)" class="btn btn-primary btn-confirm">
              Save
            </button>
            <button @click="toggleOffcanvas()" class="btn btn-outline-primary mx-3">
              Close
            </button>
          </div>
        </div>
      </b-sidebar>

      <!-- <b-sidebar id="my-sidebar" :visible="isOffcanvasOpen" shadow right>
        <div class="sidebar-content p-4">
          <div class="note-header">
            <h2 class="modal-heading">Notes</h2>

            <i v-if="selectedNoteIndex > -1" class="fas fa-trash-alt" @click="removeNote(selectedNoteIndex)"></i>
          </div>
          <div class="note-content">
            <p v-if="selectedNote.text">{{ selectedNote.text }}</p>
            <div class="form-group">
              <textarea v-model="selectedNote.comment" placeholder="Write your comment" maxlength="500"
                class="form-control notes-textarea"></textarea>
              <small class="form-text text-muted character-counter">
                {{ selectedNote.comment.length }} / 500 characters
              </small>
            </div>

            <button @click="setComment(selectedNoteIndex, selectedNote.comment)" class="btn btn-primary btn-confirm">
              Save
            </button>

            <button @click="toggleOffcanvas()" class="btn btn-outline-primary mx-3">
              Close
            </button>
          </div>
        </div>
      </b-sidebar> -->

    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { encrypt, decrypt } from "./freetext.helper";
import DataEncrypter from './data_encrypter'
import Calculator from "./../Calculator.vue";
import AIAssitant from "../AIAssitant.vue";
export default {
  name: "FreeText",
  components: {
    Calculator,
    AIAssitant

  },
  data() {
    return {
      quillEditor: null,
      ePubEditor: null,
      selectedRange: null,
      highlightedRanges: [],
      highlightedBookmark: [],
      notes: [],
      currentTab: null,
      selectedNote: { comment: '' },
      selectedNoteIndex: -1,
      isOffcanvasOpen: false,
      isAIAssitantOpen: false,
      isNotesListVisible: false,
      isHighlightsListVisible: false,
      showCalculator: false,
      currentPrompt: "",
      highlightColors: [ 
       'yellow', 'rgb(0, 156, 199)' ,
       'rgb(111, 156, 33)', 'rgb(209, 125, 0)',
       'rgb(252, 84, 84)' , 'rgb(192, 97, 255)' 
      ],
      aiAssistantOptions: [
        { menu: 'Ask To Explain', chatMessage: 'Please explain {msg}' },
        { menu: 'Ask To Give Examples', chatMessage: 'Give few examples of {msg}' },
        { menu: 'Ask', chatMessage: '{msg}' },

      ],
      isQuillSupported: false,
      currentFontFamily: 'default',
      fontFamilies: [
        {"value": "default", "label": "Default"},
        {"value": "arial", "label": "Arial"},
        {"value": "verdana", "label": "Verdana"},
        {"value": "times-new-roman", "label": "Times New Roman"},
        {"value": "georgia", "label": "Georgia"},
        {"value": "courier-new", "label": "Courier New"},
        {"value": "tahoma", "label": "Tahoma"},
        {"value": "lucida-sans", "label": "Lucida Sans"},
        {"value": "trebuchet-ms", "label": "Trebuchet MS"},
        {"value": "impact", "label": "Impact"}
      ],
      currentFontSizePercent: 0,
      currentLineHeightPercent: 0,
      currentMargin: 50,
      colorMode: 'light',
      isAnyTextSeleCted: false,
      speechSynthesis: null,
      speechWordIndex: -1,
      speechWords: [],
      isFullScreen: false,
      highlightedSelectedId: null,
      showMore: false,
      contentSearch: '',
      searchResults: [],
      searchIndex: -1,
      animationFrameId: null,
      notesShowMore: {},
      highlightsShowMore: {},
      isFreetextSearchVisible: false,
      actionsLoading: { markcompleted: false, rating: false, bookmark: false }

    };
  },
  props: {
    contentData: Object,
    isShowFloatingOptions: Boolean,
    isBookmarked: Boolean
  },
  methods: {
    ...mapActions("content", ["getContentById", "setUserContentAction", "getUserContentAction", "updateAction"]),
    ...mapActions("productVariant", ["getProductVariantProgress"]),

    manageHighlight(color)
    {
      if(this.selectedHighlightColor == color)
       { 
        this.unhighlight() 
       } 
       else{ this.highlight(color)}
    },

    setBookmark: function () {
      this.actionsLoading.bookmark = true;
      this.$emit("setContentBookmarked");
      setTimeout(() => { this.actionsLoading.bookmark = false; }, 700)
    },

    manageBookmark(){
          if(!this.isFreetextBookmarked || this.isAnyTextSeleCted){ 
            this.initializeBookmark([]);
            this.setFreetextBookmark() 
          } 
          else{ this.removeFreetextBookmark() }
    },

    setFreetextBookmark() {

      let highlightedBookmark = this.ePubEditor.bookmarkMarker.highlightSelection("bookmark");
        let bookmark = null;
        if (highlightedBookmark.length <= 0 || !highlightedBookmark[0].getHighlightElements()?.find(x => x) || !highlightedBookmark[0].getHighlightElements()[0]?.getAttribute("data-bookmark-id")) {
          bookmark = {
            id: generateGUID(),
          };
          highlightedBookmark[0].getHighlightElements()[0].setAttribute("data-bookmark-id", note.id);
        }

        bookmark.startIndex = highlightedBookmark[0].characterRange.start;
        bookmark.endIndex = highlightedBookmark[0].characterRange.end;
        bookmark.text = highlightedBookmark[0].getText();

        this.highlightedBookmark = [bookmark];


    this.actionsLoading.bookmark = true;

    if (this.contentData && this.contentData.id) {
        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "freetextBookmark",
          Data: JSON.stringify(this.highlightedBookmark)
        }

        this.setUserContentAction(contentAction).then((action) => {
          this.actionsLoading.bookmark = false;
          this.updateAction(action);
          const dataList = this.freetextBookmarkData || [];
          this.initializeBookmark(dataList);
        });
      }
  },
    removeFreetextBookmark(){
      this.actionsLoading.bookmark = true;

    if (this.contentData && this.contentData.id) {
        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "freetextBookmark",
          Data: JSON.stringify([])
        }

        this.setUserContentAction(contentAction).then((action) => {
          this.actionsLoading.bookmark = false;
          this.updateAction(action)
          this.initializeBookmark([]);
        });
      }
    },
    toggleCalculator(state) {
      if (state !== undefined) {
        this.showCalculator = state;
      } else {
        this.showCalculator = !this.showCalculator;
      }
    },
    highlight: function (color = null) {
      if (this.isQuillSupported && this.quillEditor) {
        if (this.selectedRange) {
          var range = this.selectedRange;
          let overlappingRanges = [];
          for (let i = 0; i < this.highlightedRanges.length; i++) {
            const selectedRange = this.highlightedRanges[i];
            const endIndex = selectedRange.index + selectedRange.length - 1;

            if (range.index >= selectedRange.index && range.index <= endIndex) {
              overlappingRanges.push(i);
            }
          }
          if (overlappingRanges.length === 0) {

            var prependedRange = this.highlightedRanges.find(x => x.index + x.length == range.index);
            if (prependedRange) {
              var index = this.highlightedRanges.indexOf(prependedRange);
              this.highlightedRanges[index].length += range.length;
              this.quillEditor.formatText(this.highlightedRanges[index].index, this.highlightedRanges[index].length, 'highlights', true);
            } else {
              var selectedContent = this.quillEditor.getContents(range.index, range.length);
              var tempContainer = document.createElement('div')
              var tempQuill = new Quill(tempContainer);
              tempQuill.setContents(selectedContent);
              var text = tempContainer.querySelector('.ql-editor').innerHTML;
              this.quillEditor.formatText(range.index, range.length, 'highlights', true);
              range.id = generateGUID();
              range.text = text;
              this.highlightedRanges.push(range);
            }
          } else {
            overlappingRanges.forEach(overlapRange => {
              var overlapRangeOB = this.highlightedRanges[overlapRange];
              if ((range.index + range.length) <= (overlapRangeOB.index + overlapRangeOB.length)) {
                this.quillEditor.formatText(overlapRangeOB.index, overlapRangeOB.length, 'highlights', false);
                this.highlightedRanges.splice(overlapRange, 1);

                var firstLength = range.index - overlapRangeOB.index;
                if (firstLength > 0) {
                  var selectedContent = this.quillEditor.getContents(overlapRangeOB.index, firstLength);
                  var tempContainer = document.createElement('div');
                  var tempQuill = new Quill(tempContainer);
                  tempQuill.setContents(selectedContent);
                  var text = tempContainer.querySelector('.ql-editor').innerHTML;
                  this.quillEditor.formatText(overlapRangeOB.index, firstLength, 'highlights', true);
                  this.highlightedRanges.push({ index: overlapRangeOB.index, length: firstLength, id: generateGUID(), text });
                }

                var secondLength = (overlapRangeOB.index + overlapRangeOB.length) - (range.index + range.length);
                if (secondLength > 0) {
                  var selectedContent = this.quillEditor.getContents(range.index + range.length, secondLength);
                  var tempContainer = document.createElement('div')
                  var tempQuill = new Quill(tempContainer);
                  tempQuill.setContents(selectedContent);
                  var text = tempContainer.querySelector('.ql-editor').innerHTML;

                  this.highlightedRanges.push({ index: range.index + range.length, length: secondLength, id: generateGUID(), text });

                  this.quillEditor.formatText(range.index + range.length, secondLength, 'highlights', true);
                }

              }
              else {
                this.highlightedRanges[overlapRange].length = (range.index + range.length) - overlapRangeOB.index;
                this.quillEditor.formatText(this.highlightedRanges[overlapRange].index, this.highlightedRanges[overlapRange].length, 'highlights', true);
              }

            });
          }
          this.setHighlight();
        }
      }
      else if (this.ePubEditor) {
        let highLightedNote = [];

        highLightedNote = this.ePubEditor.highlighter.highlightSelection("highlight");

        if (highLightedNote && highLightedNote.length > 0) {
          highLightedNote.forEach(function (h, i, arr) { h.getHighlightElements().forEach(function (el, i, arr) { h.id = generateGUID(); el.style.backgroundColor = color ?? 'yellow'; el.setAttribute("data-highlightid", h.id); }); });
        }
        this.ePubEditor.document.body.click();
        const selection = this.ePubEditor.highlighter.highlights;
        this.highlightedRanges = selection.map(x => {
          let color = x.getHighlightElements()?.find(x => x)?.style?.backgroundColor ?? "yellow";
          return {
            index: x.characterRange.start, length: x.characterRange.end - x.characterRange.start, id: x.id, text: x.getText(), color
          }
        });
   
        this.setHighlight();
        this.ePubEditor.getSelection()?.removeAllRanges();
      }
    },
    unhighlight: function () {
      if (this.isQuillSupported && this.quillEditor) {
      }
      else if (this.ePubEditor) {
        let highlightedEle = this.ePubEditor.highlighter.unhighlightSelection(this.ePubEditor.rangy.getSelection());
        let self = this;
        if (highlightedEle && highlightedEle.length > 0) {
          highlightedEle.forEach(function (h, i, arr) {
            let elements = self.ePubEditor.document.querySelectorAll(`span[data-highlightid="${h.id}"]`);
            elements = { ...h.getHighlightElements(), ...elements };
            Object.values(elements).forEach(function (el, i, arr) { console.log(el, "elem"); el.removeAttribute("style"); el.removeAttribute("class"); el.removeAttribute("data-highlightid"); });
          });

        }
        const selection = this.ePubEditor.highlighter.highlights;
        this.highlightedRanges = selection.map(x => {
          let color = x.getHighlightElements()?.find(x => x)?.style?.backgroundColor ?? "yellow";
          return {
            index: x.characterRange.start, length: x.characterRange.end - x.characterRange.start, id: x.id, text: x.getText(), color
          }
        });

        this.setHighlight();
        this.highlightedSelectedId = null;
        this.ePubEditor.getSelection()?.removeAllRanges();
      }
    },
    setComment(index, comment) {
      if (index == null || index == undefined || index < 0) {
        this.selectedNote.comment = comment;
        this.isOffcanvasOpen = false;
        this.showMore = false;
        this.notes[this.notes.length - 1] = this.selectedNote;
        this.setNotes()
      }

      if (this.notes.length > 0 && (this.notes.length - 1) >= index) {
        this.notes[index].comment = comment;
        this.isOffcanvasOpen = false;
        this.setNotes()
      }
    },
    removeNote(index) {

      if (this.notes.length > 0 && index >= 0 && index < this.notes.length) {
        const note = this.notes[index];
        if (this.isQuillSupported) {
          this.quillEditor.formatText(note.startIndex, note.endIndex, 'notes', false);
        } else if (this.ePubEditor) {
          let self = this
          this.ePubEditor.document.querySelectorAll(`span[data-note-id="${note.id}"]`)
            ?.forEach(function (_note, ind, arr) {
              let range = self.ePubEditor.document.createRange(); // Create a range object                
              range.selectNodeContents(window.document.body);
              range.selectNode(_note);
              let selection = self.ePubEditor.getSelection(); // Get the selection object
              selection.removeAllRanges(); // Remove any existing selection
              selection.addRange(range); //
              self.ePubEditor.noteMarker.unhighlightSelection(self.ePubEditor.rangy.getSelection());

              _note.removeAttribute("style");
              _note.removeAttribute("class");
              _note.removeAttribute("data-note-id");

            });
        }
        this.notes.splice(index, 1);

        this.isOffcanvasOpen = false;
        this.selectedNote = { comment: '' };
        this.selectedNoteIndex = -1;

        this.setNotes()

      }
    },
    takeNotes: function () {
      if (this.isQuillSupported && this.quillEditor) {
        if (this.selectedRange) {
          var range = this.quillEditor.getSelection();
          if (range) {

            let note = {
              id: generateGUID(),
              comment: ''
            };

            this.quillEditor.formatText(range, 'notes', true);

            note.range = range;
            note.startIndex = range.index;
            note.endIndex = range.length;
            note.text = this.quillEditor.getText(note.startIndex, note.endIndex);

            let { condition, intersectingNote, intersectingIndex } = this.checkRangeIntersection(note);

            if (!condition) {
              this.isOffcanvasOpen = true;

              this.selectedNote = { comment: '', ...note };
              this.selectedNoteIndex = -1;
            }

            try {
              this.notes.push(note);
            } catch (e) {
              this.notes = [];
            }

          }
        }
      }
      else if (this.ePubEditor) {


        let highLightedNote = this.ePubEditor.noteMarker.highlightSelection("notes");
        let note = null;
        if (highLightedNote.length <= 0 || !highLightedNote[0].getHighlightElements()?.find(x => x) || !highLightedNote[0].getHighlightElements()[0]?.getAttribute("data-note-id")) {
          note = {
            id: generateGUID(),
            comment: ''
          };
          highLightedNote[0].getHighlightElements()[0].setAttribute("data-note-id", note.id);
          this.notes.push(note);
        }
        note = this.notes.find(x => x.id == highLightedNote[0].getHighlightElements()[0]?.getAttribute("data-note-id"));

        note.startIndex = highLightedNote[0].characterRange.start;
        note.endIndex = highLightedNote[0].characterRange.end;
        note.text = highLightedNote[0].getText();
        this.isOffcanvasOpen = true;
        this.selectedNote = note;
        this.selectedNoteIndex = this.notes.indexOf(note);
        this.setNotes();
      }

    },
    rangesIntersect: function (range1, range2) {
      return range1.index < range2.index + range2.length && range2.index < range1.index + range1.length;
    },
    checkRangeIntersection(newNote) {
      let intersectingNote = null;
      let intersectingIndex = -1;

      for (let i = 0; i < this.notes.length; i++) {
        const existingNote = this.notes[i];
        if (existingNote.range && this.rangesIntersect(newNote.range, existingNote.range)) {
          intersectingNote = existingNote;
          intersectingIndex = i;
          break;
        }
      }

      return {
        condition: intersectingNote !== null,
        intersectingNote: intersectingNote,
        intersectingIndex: intersectingIndex
      };
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    toggleNotesListShowMore(note) {
      let tempObject = this.notesShowMore;
      tempObject[note.id] = !(tempObject[note.id] === true) ;
      this.notesShowMore = null;
      this.notesShowMore = tempObject;
    },
    toggleHighlightsListShowMore(highlight) {
     let tempObject = this.highlightsShowMore;
      tempObject[highlight.id] = !(tempObject[highlight.id] === true) ;
      this.highlightsShowMore = null;
      this.highlightsShowMore = tempObject;
    },
    toggleOffcanvas() {
      this.isOffcanvasOpen = !this.isOffcanvasOpen;

      if(isNotesListVisible) isNotesListVisible = false;
      if(isHighlightsListVisible) isHighlightsListVisible = false;

      if (!this.isOffcanvasOpen) { this.showMore = false }
    },
    setNotes() {
      if (this.contentData && this.contentData.id) {
        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "notes",
          Data: JSON.stringify(this.notes)
        }

        this.setUserContentAction(contentAction).then((action) => {
          this.updateAction(action)
          this.initializeNotes();
        });
      }
    },
    getNotes: function () {
      this.getUserContentAction({ contentId: this.contentData.id, dataType: "notes" }).then((userActions) => {
        var userAction = userActions ? userActions.find(x => x.dataType == "notes") : null;
        if (userAction) {

          if (this.notes && this.notes.length > 0 && this.isQuillSupported) {
            this.notes.forEach(note => {
              this.quillEditor.formatText(note.startIndex, note.endIndex, 'notes', false);
            });
          }

          if (userAction.data) {
            let parsedData = JSON.parse(userAction.data);
            this.notes = parsedData;
            if (this.isQuillSupported) {
              this.notes.forEach(note => {
                this.quillEditor.formatText(note.startIndex, note.endIndex, 'notes', true);
              });
            } else {
              this.initializeNotes()
            }

          }
        }
      });
    },
    initializeNotes() {
      let charRanges = this.notes.map(x => {
        var range = this.ePubEditor.noteMarker.converter.rangeToCharacterRange(this.ePubEditor.noteMarker.converter.characterRangeToRange(this.ePubEditor.document.body, { start: 0, end: 1 }, this.ePubEditor.document));
        range.start = x.startIndex; range.end = x.endIndex;

        let highLightedNote = this.ePubEditor.noteMarker.highlightCharacterRanges("notes", [range]);
        highLightedNote.forEach(function (h, ind, arr) { h?.getHighlightElements().forEach(function (e, i, _arr) { e?.setAttribute("data-note-id", x.id) }) });
        return range
      });

      if (this.$route?.query?.noteId) {
        this.scrollToNote(this.$route.query.noteId)
      }
    },
    initializeBookmark(bookmarkList) {
      
      const bookmarkElements = this.ePubEditor.document.querySelectorAll('.bookmark');
      bookmarkElements.forEach(element => {
        element.classList.remove('bookmark');
        element.removeAttribute('data-bookmark-id');
      });

      this.highlightedBookmark = bookmarkList;

      let charRanges = this.highlightedBookmark.map(x => {
        var range = this.ePubEditor.bookmarkMarker.converter.rangeToCharacterRange(
          this.ePubEditor.bookmarkMarker.converter.characterRangeToRange(
            this.ePubEditor.document.body, 
            { start: 0, end: 1 }, 
            this.ePubEditor.document
          )
        );

        range.start = x.startIndex; 
        range.end = x.endIndex;

        let highlightedBookmark = this.ePubEditor.bookmarkMarker.highlightCharacterRanges("bookmark", [range]);
        highlightedBookmark.forEach(function (h) {
          h?.getHighlightElements().forEach(function (e) {
            e?.setAttribute("data-bookmark-id", x.id);
          });
        });

        return range;
      });

      if (this.highlightedBookmark.length > 0) {
        const currentBookmark = this.highlightedBookmark[0];
       this.scrollToFreetextBookmark(currentBookmark.id);
      }
    },
    setHighlight: function () {

      if (this.contentData && this.contentData.id) {
        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "highlights",
          Data: JSON.stringify(this.highlightedRanges)
        }

        this.setUserContentAction(contentAction).then((action) => {
          this.updateAction(action)
          this.initializeHighlights()
        });
      }

    },
    getHighlights: function () {
      this.getUserContentAction({ contentId: this.contentData.id, dataType: "highlights" }).then((userActions) => {
        var userAction = userActions ? userActions.find(x => x.dataType == "highlights") : null;
        if (userAction) {
          if (this.highlightedRanges && this.highlightedRanges.length > 0 && this.isQuillSupported) {
            this.highlightedRanges.forEach(highlighted => {
              this.quillEditor.formatText(highlighted.index, highlighted.length, 'highlights', false);
            });
          }
          this.highlightedRanges = JSON.parse(userAction.data);

          if (this.isQuillSupported) {
            this.highlightedRanges.forEach(highlighted => {
              this.quillEditor.formatText(highlighted.index, highlighted.length, 'highlights', true);
            });
          } else {
            this.initializeHighlights()
          }

        }
      });
    },
    initializeHighlights() {
      let charRanges = this.highlightedRanges.map(x => {
        var range = this.ePubEditor.highlighter.converter.rangeToCharacterRange(this.ePubEditor.highlighter.converter.characterRangeToRange(this.ePubEditor.document.body, { start: 0, end: 1 }, this.ePubEditor.document));
        range.start = x.index; range.end = x.index + x.length;
        let color = x.color ?? "yellow";
        let highLightedNote = this.ePubEditor.highlighter.highlightCharacterRanges("highlight", [range]);
        if (highLightedNote && highLightedNote.length > 0) {
          highLightedNote.forEach(function (h, i, arr) { h.id = x.id; h.getHighlightElements().forEach(function (el, i, arr) { el.style.backgroundColor = color ?? 'yellow'; el.setAttribute("data-highlightid", x.id); }); });
        }
        return range
      });

      if (this.$route?.query?.highlightId) {
        this.scrollToHighlight(this.$route.query.highlightId)
      }
    },
    handleNotesClick(event) {
      if (event.target.classList.contains('notes')) {
        const notesTarget = event.currentTarget;
        const text = notesTarget.innerText;
        const noteIndex = this.notes.findIndex(x => x.text.includes(text));

        if (noteIndex > -1) {
          this.selectedNoteIndex = noteIndex;
          this.selectedNote = this.notes[noteIndex];
        }

        if (!this.isOffcanvasOpen) {
          this.toggleOffcanvas()
        }
      }
    },
    handleNotesHighlightClick(noteid) {

      const noteIndex = this.notes.findIndex(x => x.id == noteid);
      if (noteIndex > -1) {
        this.selectedNoteIndex = noteIndex;
        this.selectedNote = this.notes[noteIndex];
        if (!this.isOffcanvasOpen) {
          this.toggleOffcanvas()
        }
      }



    },


    increaseFontSize() {
      if (this.currentFontSizePercent < 100)
        this.currentFontSizePercent += 2;

    },
    decreaseFontSize() {
      if (this.currentFontSizePercent > -40)
        this.currentFontSizePercent -= 2;

    },
    setDefaultFontSize() {
      this.currentFontSizePercent = 0;
    },

    playSelected() {
    if (this.speechSynthesis) {
        this.speechSynthesis.cancel();
    }

    if ('speechSynthesis' in window) {
        const self = this;
        let selection = this.ePubEditor.rangy.getSelection();
        let selectedText = selection.toString();

        // Create a single SpeechSynthesisUtterance instance
        const msg = new SpeechSynthesisUtterance();

        if (this.isAnyTextSeleCted) {
            // Split the text into words with their start and end positions
            this.speechWords = this.getWordsWithRanges(selectedText, selection, undefined);
            msg.text = selectedText;  // Set the text for the utterance
        } else {
            const mainContent = this.ePubEditor.document.getElementById('main-c');
            if (!mainContent) return;

            const scopeRange = this.ePubEditor.rangy.createRange();
            scopeRange.selectNodeContents(mainContent);
            selection.removeAllRanges();
            selection.addRange(scopeRange);
            this.speechWords = this.getWordsWithRanges(mainContent.textContent, undefined, scopeRange);
            msg.text = mainContent.textContent;  // Set the full content text for the utterance
        }

        const words = [...this.speechWords];
        selection.removeAllRanges();

       
       try{ // Set voice and other properties
        let voice = this.getBestVoice();
        msg.voice = voice;
       }
       catch(e){
        console.log("Error using best voice: ", e)
       }
        // Track current word index
        let currentIndex = 0;

        // Handle the 'boundary' event to highlight the current word
        msg.onboundary = (event) => {
            if (event.name === 'word') {
                self.speechWordIndex = currentIndex;
                const word = words[currentIndex];
                if (word && word.range) {
                  try{
                    // Remove previous highlight
                    if (currentIndex > 0) {
                        self.ePubEditor.speechMarker.classAppliers.speechHighlight.undoToRanges([words[currentIndex - 1].range]);
                    }

                    // Highlight the current word
                    self.ePubEditor.speechMarker.classAppliers.speechHighlight.applyToRanges([word.range]);
                  }
                  catch(e){}
                  finally{
                    // make sure index increses if due to some reason words have issue rendering
                    currentIndex++;
                  }
                }
            }
        };

        // Handle the 'end' event to remove the last highlight
        msg.onend = () => {
            if (currentIndex > 0) {
                self.ePubEditor.speechMarker.classAppliers.speechHighlight.undoToRanges([words[currentIndex - 1].range]);
            }
            self.speechSynthesis = null;
            self.speechWordIndex = -1;
            selection.removeAllRanges(); // Clear the selection
        };

        // Speak the selected text or the entire main content
        window.speechSynthesis.speak(msg);
        this.speechSynthesis = window.speechSynthesis;
    } else {
        console.error('Speech synthesis not supported.');
    }
    },


    getBestVoice() {
      const voices = window.speechSynthesis.getVoices();

      const userAgent = navigator.userAgent;

      let preferredVoices = [];

      if (/Windows/i.test(userAgent)) {
          preferredVoices = [
              'Microsoft Mark - English (United States)', 
              'Microsoft David - English (United States)',
              'Google UK English Female'
          ];
      } else if (/Macintosh/i.test(userAgent)) {
          preferredVoices = [ 'Alex', 'Google US English', 'Google UK English Female'  ];
      } else if (/iPhone|iPad/i.test(userAgent)) {
          preferredVoices = [
              'Samantha', 
              'Google US English', 
              'Google UK English Female' 
          ];
      } else if (/Android/i.test(userAgent)) {
          preferredVoices = [ 'Google US English', 'Google UK English Female' ];
      } else {
          preferredVoices = [
              'Google US English', 
              'Google UK English Female', 
              'Microsoft Zira Desktop' 
          ];
      }

      let voice = voices.find(v => preferredVoices.includes(v.name) && v.default && v.lang.startsWith('en')) ||
                  voices.find(v => v.default && v.lang.startsWith('en-US')) ||
                  voices.find(v => v.default && v.lang.startsWith('en-GB')) ||
                  voices.find(v => v.default && v.lang.startsWith('en'));

      return voice || (voices.length > 0 ? voices[0] : null);
},


getWordsWithRanges(text, selection, providedRange = undefined) {
    const range = providedRange ? providedRange : selection.getRangeAt(0);
    const textNodes = this.getTextNodesInRange(range);
    const words = [];
    let nodeIndex = 0; // Track the current text node index
    let position = 0; // Track the current position within the text node

    // Split the text into words while considering punctuation
    // This regex considers words with hyphens and removes surrounding punctuation
    const wordRegex = /\b[\w-]+\b/g;
    let wordMatch;

    // Use regex to find words in the provided text
    while ((wordMatch = wordRegex.exec(text)) !== null) {
        const word = wordMatch[0]; // The matched word
        let wordFound = false;

        while (nodeIndex < textNodes.length) {
            const textNode = textNodes[nodeIndex];
            const textContent = textNode.textContent;
            const startIndex = textContent.indexOf(word, position);

            if (startIndex !== -1) {
                const endIndex = startIndex + word.length;

                // Create Rangy Range
                const rangyRange = this.ePubEditor.rangy.createRange();
                rangyRange.setStart(textNode, startIndex);
                rangyRange.setEnd(textNode, endIndex);

                words.push({
                    text: word,
                    range: rangyRange
                });

                position = endIndex; // Move position forward
                wordFound = true;
                break;
            } else {
                position = 0; // Reset position when moving to the next text node
                nodeIndex++; // Move to the next text node
            }
        }

        if (!wordFound) {
            // Handle cases where the word wasn't found in any text node
            console.warn(`Word "${word}" not found in the provided text nodes.`);
        }
    }

    return words;
},


    // Helper function to get all text nodes within a range
    getTextNodesInRange(range) {
      const textNodes = [];
      const iterator = document.createNodeIterator(
        range.commonAncestorContainer,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      let currentNode;
      while ((currentNode = iterator.nextNode())) {
        if (range.intersectsNode(currentNode)) {
          textNodes.push(currentNode);
        }
      }

      return textNodes;
    },


    setTextAlign(alignment) {
      var elements = this.ePubEditor.document.querySelectorAll('*');
      let self = this;
      // Loop through each element
      elements.forEach(function (element) {
        element.style.textAlign = alignment;
      });
      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");


    },
    getLuminance(color) {
      const rgb = color.substring(4, color.length - 1)
        .replace(/ /g, '')
        .split(',');

      const [r, g, b] = rgb.map(value => {
        value /= 255; // Convert RGB to sRGB
        return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
      });

      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    },
    setMode(_colorMode) {
      this.setdefaultMode();
      this.ePubEditor.document.body.classList.remove(this.colorMode);
      this.colorMode = _colorMode;

      this.ePubEditor.document.body.classList.add(this.colorMode);
      var elements = this.ePubEditor.document.querySelectorAll('*');
      var self = this;
      elements.forEach(element => {
        
        const computedStyle = this.ePubEditor.getComputedStyle(element);
        const backgroundColor = computedStyle.backgroundColor;

        if (backgroundColor && self.getLuminance(backgroundColor) > 0.5 &&
          !element.classList.contains("highlight") && !element.classList.contains("notes")
          &&
          !element.classList.contains(_colorMode + "-element")
        ) {

          element.classList.add(_colorMode + "-element"); // Set text color to white
        }
      });
      

      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");

    },
    setdefaultMode() {
      this.ePubEditor.document.body.classList.remove(this.colorMode);
      this.colorMode = 'light';
      this.ePubEditor.document.body.classList.add(this.colorMode);
      var elements = this.ePubEditor.document.querySelectorAll('*');
      var self = this;
      elements.forEach(element => {

        element.classList.remove("custom-dark-element"); // Set text color to white
        element.classList.remove("sepia-element"); // Set text color to white

      });
      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");

    },
    initializeEPubEditor(url, html) {

      let self = this;
      
      let editor = document.getElementById("html-Editor").contentWindow;
      let resizeObserver = new ResizeObserver(() => {
        if (document.getElementById("html-Editor"))
          // document.getElementById("html-Editor").style.height = editor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height??((self.ePubEditor.document.body.scrollHeight) + "px");

          var iFrameCurrentHeight = editor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");
        var iFrameCurrentHeightVal = parseInt(iFrameCurrentHeight.replace('px', ''));
        var iFrameNewHeightVal = iFrameCurrentHeightVal + 20;
        document.getElementById("html-Editor").style.height = iFrameNewHeightVal + "px";

      });

      resizeObserver.observe(document.getElementById("html-Editor"))
      // editor.document.location.reload();
      editor.document.addEventListener('contextmenu', (event) => {
        event.preventDefault();

        // Get existing menu style and positioning
        let existingMenu = editor.document.querySelector('.context-menu');
        if (existingMenu) menuStyle = existingMenu.innerHTML = '';
      });

      this.ePubEditor = editor;

      let headContent = html.match(/<head[^>]*>([\s\S]*?)<\/head>/i);
      let bodyContent = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);

      if (bodyContent) {
          // inject only body instead of html
          self.ePubEditor.document.write("<div id='main-c'>" + bodyContent[1] + "</div>");
      } else {
          // if body dont exists inject what ever is coming
          self.ePubEditor.document.write("<div id='main-c'>" + html + "</div>");
      }



      let allImages = self.ePubEditor.document.querySelectorAll("img");

      allImages.forEach(function (img, ind, arr) {
        var src = img.getAttribute('src');
        if (!img.complete && src && !src.startsWith('http') && !src.startsWith('data:image') && !src.startsWith('//')) {
          let srcDomain = url.split("/");
          srcDomain.pop();
          img.setAttribute('src', srcDomain.join("/") + "/" + src);
        }
      });


      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");

      // this.ePubEditor.document.write("<div id='main-c'>" + this.contentData.data + "</div>");
      document.getElementById("html-Editor").style.width = "100%";
      setTimeout(function () {
        // initialize template
        editor.document.body.innerHTML += (`<template></template>`);

        // editor.document.body.innerHTML += (`<template><span style="width:50px;">
        //     <a href="#" title="Unhighlight" data-event="unhighlight"  style="flex: 1; border-left:1px solid rgb(132,132,132); position:relative; margin-right: 5px; color:black; " class="float-icon unhighlight">  <i style="left: 10px;top:2px; position: absolute;" class="fa fa-trash toolbox-icon"></i></a> </span></template>`);
        
        // editor.document.body.innerHTML += (`<template><span id="control">
        //       <a href="#" title="Highlight" data-event="highlight" data-color='yellow' style="flex: 1; margin-right: 10px; background-color:yellow;" class="float-icon">  </a>  
        //       <a href="#" title="Highlight" data-event="highlight"  data-color='rgb(0, 156, 199)'  style="flex: 1; margin-right: 10px; background-color: rgb(0, 156, 199);" class="float-icon"> </a>  
        //       <a href="#" title="Highlight" data-event="highlight"  data-color='rgb(111, 156, 33)'  style="flex: 1; margin-right: 10px; background-color: rgb(111, 156, 33);" class="float-icon"> </a>  
        //       <a href="#" title="Highlight" data-event="highlight"  data-color='rgb(209, 125, 0)' style="flex: 1; margin-right: 10px; background-color: rgb(209, 125, 0);" class="float-icon"> </a>  
        //       <a href="#" title="Highlight" data-event="highlight"  data-color='rgb(252, 84, 84)' style="flex: 1; margin-right: 10px; background-color: rgb(252, 84, 84);" class="float-icon">  </a>     
        //       <a href="#" title="Highlight" data-event="highlight"  data-color='rgb(192, 97, 255)'  style="flex: 1; margin-right: 5px; background-color: rgb(192, 97, 255)" class="float-icon">  </a>
        //       <a href="#" title="Speak" data-event="speak"   style="flex: 1; position:relative; border-left:1px solid rgb(132,132,132);  color:black; margin-right: 15px;" class="float-icon">  <i style="left: 10px;top:2px; position: absolute;" class="fas fa-volume-up  toolbox-icon"></i></a> 
        //       <a href="#" title="AI Help" data-event="aiHelp"   style="flex: 1; position:relative; border-left:1px solid rgb(132,132,132);  color:black; margin-right: 15px;" class="float-icon">   <img  style="left: 10px;top:2px; position: absolute; width:18px" src="${document.querySelector(".ai-icon img").src}"></a> 
        //       <a href="#" title="Note" data-event="takeNote"   style="flex: 1; border-left:1px solid rgb(132,132,132); position:relative; margin-right: 5px; color:black; " class="float-icon takeNote">  <i style="left: 10px;top:2px; position: absolute;" class="fa fa-sticky-note toolbox-icon"></i></a>
        //       <a href="#" title="Unhighlight" data-event="unhighlight"   style="flex: 1; border-left:1px solid rgb(132,132,132); position:relative; margin-right: 5px; color:black; " class="float-icon unhighlight">  <i style="left: 10px;top:2px; position: absolute;" class="fa fa-trash toolbox-icon"></i></a> </span></template>`);

        var control = editor.document.importNode(editor.document.querySelector('template').content, true).childNodes[0];
        // logic removed bcz it was conflicting height simply set the height to auto
        //document.getElementById("html-Editor").style.height = editor.getComputedStyle(editor.document.getElementById("main-c"))?.height??((self.ePubEditor.document.body.scrollHeight) + "px");
        var css = `.bookmark { } .currentSearchResult { border: 2px solid red; color:white; background: black; } .searchResult { border: 2px solid red; } #html-Editor{height: auto} mjx-container.MathJax {pointer-events: none;} #main-c { overflow:auto;} body { margin: 20px; overflow: hidden; word-break: keep-all} #control {   cursor: pointer;  position: absolute;  width: 330px; height: 40px;  border-radius: 2px;  background-color: white !important;  text-align: center;    align-content: center;  border: 1px solid lightgrey;}
                     #control::before{  position: absolute;  content: '';  border-top: 10px solid lightgrey;  border-left:10px solid transparent;  border-right: 10px solid transparent;  left: 110px;  top: 40px;}
                     #control a{  display: inline-block;  width: 20px;  height: 20px;  background-repeat: no-repeat;  background-position: center;  background-size: 70%;}
                     .custom-dark *:not(th):not(th *):not(.do-not-apply):not(.do-not-apply *) {color:white;}  
                     .custom-dark-element:not(table):not(table *):not(.do-not-apply):not(.do-not-apply *) { background: #333; color: #FFF;}
                     .custom-dark table *:not(th):not(th *):not(.do-not-apply):not(.do-not-apply *) { color: #333; } 
                     .sepia *:not(th):not(th *) {color:rgb(139, 82, 32);}   
                     .sepia-element:not(table):not(table *) { background:rgb(255, 242, 208); color:rgb(139, 82, 32);}
                     .sepia table *:not(th):not(th *) { color: #333; } 
                     span.highlight .notes {color: black;}  .speechHighlight {background: orange;}   .highlight { background: yellow; color:black; cursor:pointer; } .notes { border-bottom:2px solid red; cursor:pointer; }  .notes:hover { background:red; color:white; }
                     @media (max-width:768px) { body { margin: 10px !important } }
                     .font-default{font-family:sans-serif !important}.font-arial{font-family:Arial,sans-serif !important}.font-verdana{font-family:Verdana,sans-serif !important}.font-times-new-roman{font-family:'Times New Roman',Times,serif !important}.font-georgia{font-family:Georgia,serif !important}.font-courier-new{font-family:'Courier New',Courier,monospace !important}.font-tahoma{font-family:Tahoma,sans-serif !important}.font-lucida-sans{font-family:'Lucida Sans',sans-serif !important}.font-trebuchet-ms{font-family:'Trebuchet MS',sans-serif !important}.font-impact{font-family:Impact,sans-serif !important}
 `;
        let style = document.createElement('style');
        style.type = 'text/css';
        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        editor.document.head.appendChild(style);

        if(headContent){
          let header = document.createElement('div');
          header.innerHTML = headContent[1];

          let tagsToExtract = ['link', 'style', 'meta', 'script'];

          tagsToExtract.forEach(tag => {
              let elements = header.getElementsByTagName(tag);
              Array.from(elements).forEach(element => {
                  let importedElement = self.ePubEditor.document.importNode(element, true);
                  self.ePubEditor.document.head.appendChild(importedElement);
              });
          });
        }
        
        var script = document.createElement('script');
        script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/rangy/1.3.0/rangy-core.min.js');
        editor.document.head.appendChild(script);
        editor.document.head.innerHTML += (`<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css" integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous">`);
        script.onload = function () {

          editor.document.addEventListener("selectionchange", () => {
            self.isAnyTextSeleCted = !editor.document.getSelection().isCollapsed;

            if (!self.isAnyTextSeleCted && self.highlightedSelectedId) {
              self.highlightedSelectedId = null
            }
          });

          self.$nextTick(() => {
            // Ensure the editor is ready
            const editorDocument = editor.document;
            const editorWindow = editorDocument.defaultView || editorDocument.parentWindow;
            editorWindow.focus();
          });


          editor.document.addEventListener('keydown', function (event) {

            // Check if the pressed key is F11
            if (self.isFullscreenSupported() && (event.key === 'F11' || event.keyCode === 122)) {
              event.preventDefault();

              if (!self.isFullScreen) { self.makeFullscreen() }
              else { self.exitFullscreen() }
            }
          });

          script = document.createElement('script');
          script.setAttribute('src', 'https://rawgit.com/timdown/rangy/master/lib/rangy-highlighter.js');
          editor.document.head.appendChild(script);
          script.onload = function () {

            script = document.createElement('script');
            script.setAttribute('src', 'https://rawgit.com/timdown/rangy/master/lib/rangy-classapplier.js');
            editor.document.head.appendChild(script);
            script.onload = function () {

              var textRangeScript = document.createElement('script');
              textRangeScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/rangy/1.3.1/rangy-textrange.js');
              editor.document.head.appendChild(textRangeScript);
              textRangeScript.onload = function () {
              
              editor.rangy.init();
              editor.noteMarker = editor.rangy.createHighlighter();
              editor.noteMarker.addClassApplier(editor.rangy.createClassApplier('notes', {
                elementProperties: {
                  onclick: function () {
                    self.handleNotesHighlightClick(this.getAttribute("data-note-id"));
                    return false;
                  }
                }
              }));

              editor.highlighter = editor.rangy.createHighlighter();
              editor.highlighter.addClassApplier(editor.rangy.createClassApplier('highlight', {
                elementProperties: {
                  onclick: function () {
                    let hid = this.getAttribute("data-highlightid");
                    let highlightedElement = self.highlightedRanges.find(x => x.id == hid);
                    if (highlightedElement) {
                      let range = editor.document.createRange(); // Create a range object                
                      range.selectNodeContents(window.document.body);
                      range.selectNode(this);
                      let selection = editor.getSelection(); // Get the selection object
                      selection.removeAllRanges(); // Remove any existing selection
                      selection.addRange(range); //

                      self.highlightedSelectedId = hid;
                      self.triggerHighlightDropdown();
                    }

                  //   editor.openToolbox();
                  //   if (editor.document.querySelectorAll('#control a.unhighlight')[0])
                  //     editor.document.querySelectorAll('#control a.unhighlight')[0].style.display = 'inline-block';
                  //   if (editor.document.querySelectorAll('#control a.takeNote')[0])
                  //     editor.document.querySelectorAll('#control a.takeNote')[0].style.display = 'none';
                   }
                }
              }));

              editor.bookmarkMarker = editor.rangy.createHighlighter();
              editor.bookmarkMarker.addClassApplier(editor.rangy.createClassApplier('bookmark', {
                elementProperties: {
                  onclick: function () {
                    return false;
                  }
                }
              }));

              editor.speechMarker = editor.rangy.createHighlighter();
              editor.speechMarker.addClassApplier(editor.rangy.createClassApplier('speechHighlight', {
                elementProperties: {
                  onclick: function () {
                    return false;
                  }
              }

            }));

                editor.searchMarker = editor.rangy.createHighlighter();
                // editor.searchMarker.addClassApplier(editor.rangy.createClassApplier('currentSearchResult' ));
                editor.searchMarker.addClassApplier(editor.rangy.createClassApplier('searchResult', {
                elementProperties: {
                  onclick: function () {
                    return false;
                  }
              }

            }));

              
              
                self.getHighlights();
                self.getNotes();  

                const dataList = self.freetextBookmarkData || [];
                self.initializeBookmark(dataList);
              }



              let elems = editor.document.querySelectorAll('*');
              elems.forEach(function (ele, ind, arr) {
                ele.oncontextmenu = function (event) {
                  event.preventDefault();
                }
              });

              // Enabling MathJax
              var mathJaxScript = document.createElement('script');
              mathJaxScript.setAttribute('id', 'MathJax-script');
              mathJaxScript.setAttribute('async', '');
              mathJaxScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js');
              editor.document.head.appendChild(mathJaxScript);

              mathJaxScript.onload = function () {
                // Configure MathJax 
                var config = document.createElement('script');
                config.type = 'text/javascript';
                editor.document.head.appendChild(config);

                // Wait for MathJax to be fully loaded and typeset the content
                editor.MathJax.typesetPromise([editor.document.body]).then(() => {
                  console.log('MathJax typeset complete.');
                }).catch(err => {
                  console.error('MathJax typeset error:', err);
                });
              };


              setTimeout(() => {
                var iFrameCurrentHeight = editor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");
                var iFrameCurrentHeightVal = parseInt(iFrameCurrentHeight.replace('px', ''));
                var iFrameNewHeightVal = iFrameCurrentHeightVal + 20;
                document.getElementById("html-Editor").style.height = iFrameNewHeightVal + "px";
              }, 1200);


            }
          };
        };


        editor.openToolbox = function () {
          let selection = editor.document.getSelection(), text = selection.toString();
          if (text !== "") {
            let rect = selection.getRangeAt(0).getBoundingClientRect();
            control.style.top = `calc(${rect.top}px - 48px)`;
            control.style.left = `calc(${rect.left}px + calc(${rect.width}px / 2) - 110px)`;
            control['text'] = text;
            editor.document.body.appendChild(control);
            editor.document.querySelectorAll('#control a').forEach(function (el, ind, arr) {
              el.removeEventListener('pointerdown', editor[el.getAttribute("data-event")], true);
              el.addEventListener('pointerdown', editor[el.getAttribute("data-event")], true);
            });
          }
        }
        editor.highlight = function (color) {
          self.highlight(color.target.getAttribute("data-color"));
        }
        editor.unhighlight = function () {
          self.unhighlight();
        }
        editor.speak = function (evt) {
          self.playSelected();
        }
        editor.takeNote = function (evt) {
          self.takeNotes();
        }
        editor.aiHelp = function (evt) {
          self.getAIHelp();
        }
        editor.document.querySelector('*').onpointerup = (evt) => {
          evt.preventDefault();
          // editor.openToolbox();

          if (editor.document.querySelectorAll('#control a.unhighlight')[0])
            editor.document.querySelectorAll('#control a.unhighlight')[0].style.display = 'none';

          if (editor.document.querySelectorAll('#control a.takeNote')[0])
            editor.document.querySelectorAll('#control a.takeNote')[0].style.display = 'inline-block';
        }
        editor.document.onpointerdown = () => {
          let control = editor.document.querySelector('#control');
          if (control !== null) { control.remove(); document.getSelection().removeAllRanges(); }
        }
        editor.document.addEventListener("click", () => {
          editor.parent.document.body.click();
        });
      }, 100);

    },

    toggleAIAssistant() {
      this.isAIAssitantOpen = !this.isAIAssitantOpen;
    },
    getAIHelp(msgtxt = undefined) {
      this.isAIAssitantOpen = true;

      if (this.quillEditor && this.isQuillSupported) {
        if (this.selectedRange) {
          var range = this.selectedRange;
          var text = this.quillEditor.getText(range.index, range.length);
          if (msgtxt) {
            text = msgtxt.replaceAll("{msg}", text);
          }
          this.currentPrompt = text;
        }
      } else if (this.ePubEditor) {
        if (this.ePubEditor.getSelection() && this.ePubEditor.getSelection().isCollapsed == false) {
          var text = this.ePubEditor.getSelection().toString();
          if (msgtxt && (msgtxt?.length ?? 0) > 0) {

            text = msgtxt.replaceAll("{msg}", text);
          }
          this.currentPrompt = text;
        }
      }
    },
    triggerHighlightDropdown() {
      this.$nextTick(() => {
        this.$refs.highlightDropdown.hide(true);
        this.$refs.highlightDropdown.show();
      });
    },
    aiMenu() {
      var menuItems = {};
      this.aiAssistantOptions.forEach(function (val) {
        menuItems[val.menu] = {
          name: val.menu
        }
      });
      return menuItems;
    },
    isFullscreenSupported() {
      return document.documentElement.requestFullscreen;
    },

    makeFullscreen() {
      let mainFreetextElem = document.getElementById("main-FreetextElem");
      let mainContentList = document.getElementsByClassName('freeText-main-content');
      let mainContent  = mainContentList.length > 0 ? mainContentList[0] : null;

      if (mainFreetextElem) {
 
        mainFreetextElem.requestFullscreen()
          .then(() => {
            mainFreetextElem = document.getElementById("main-FreetextElem");

            if (mainFreetextElem) {
              mainFreetextElem.style.height = "100vh";
            }

            if(mainContent){
              mainContent.style.setProperty('height', '100%', 'important');
            }

          })
          .catch((err) => {
            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
          });
      }
    },
    exitFullscreen() {
      if (document.fullscreenElement) {

        document.exitFullscreen()
          .then(() => {
            let mainFreetextElem = document.getElementById("main-FreetextElem");
            let mainContentList = document.getElementsByClassName('freeText-main-content');
            let mainContent  = mainContentList.length > 0 ? mainContentList[0] : null;

            if (mainFreetextElem) {
              mainFreetextElem.style.height = "auto";
            }

            if (mainContent) {
              mainContent.style.removeProperty('height');
            }


          })
          .catch((err) => {
            console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
          });
      }
    },
    handleFullscreenChange() {
      let freeTextMainContent = document.getElementsByClassName("freeText-main-content");

      if (document.fullscreenElement) {
        if (freeTextMainContent.length > 0) {
          freeTextMainContent[0].classList.add('fullscreen-height');
          this.isFullScreen = true;
        }
      } else {
        if (freeTextMainContent.length > 0) {
          freeTextMainContent[0].classList.remove('fullscreen-height');
          this.isFullScreen = false;
        }
      }
    },

    markCompleted: function (isCompleted) {
      if (this.contentData.id) {
        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "completionStatus",
          Data: isCompleted ? "completed" : "uncompleted"
        }

        this.actionsLoading.markcompleted = true;

        this.setUserContentAction(contentAction).then((action) => {
          if (action && action.dataType && action.dataType.toLowerCase() == "completionstatus") {
            this.getProductVariantProgress(this.$route.params.id);
            this.updateAction({ "id": action.id, "userID": action.userID, "contentID": this.contentData.id, "dataType": action.dataType, "data": action.data });
            this.actionsLoading.markcompleted = false;
          }

        });
      }
    },

    setConfidenceLevel: function (confidenceLevel) {
      if (this.contentData.id) {
        if (this.currentRating.toLowerCase() == confidenceLevel.toLowerCase()) {
          confidenceLevel = 'Unrated';
        }

        this.$nextTick(() => {
          this.$refs.ratingDropdown.hide();
        });

        var contentAction = {
          ContentID: this.contentData.id,
          DataType: "confidence_level",
          Data: confidenceLevel
        }

        this.actionsLoading.rating = true;

        this.setUserContentAction(contentAction).then((action) => {
          if (action && action.dataType && action.dataType.toLowerCase() == "confidence_level") {
            this.updateAction(action);
            this.actionsLoading.rating = false;
          }
        });
      }
    },

    removeQueryParam(param) {
      const query = { ...this.$route.query };
      delete query[param];  

      this.$router.replace({ query });
    },

    scrollToHighlight(highlightId) {
      if (this.$route.query.highlightId) {
        this.removeQueryParam('highlightId')
      }

      this.$nextTick(() => {
        const element = this.ePubEditor.document.querySelector(`[data-highlightid="${highlightId}"]`);
        if (element) {
          if(this.isIpad){
            element.scrollIntoView({behavior: 'smooth', block: "nearest", inline: "nearest"});
          }
          else{
            element.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
          }
         

        }
      });
    },

    scrollToNote(noteId) {
      if (this.$route.query.noteId) {
        this.removeQueryParam('noteId')
      }

      this.$nextTick(() => {
        const element = this.ePubEditor.document.querySelector(`[data-note-id="${noteId}"]`);
        if (element) {
          if(this.isIpad){
            element.scrollIntoView({behavior: 'smooth', block: "nearest", inline: "nearest"});
          }
          else{
            element.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
          }
        }
      });
    },

    scrollToFreetextBookmark(bookmarkId) {
      this.$nextTick(() => {
        const element = this.ePubEditor.document.querySelector(`[data-bookmark-id="${bookmarkId}"]`);
        if (element) {
          if(this.isIpad){
            element.scrollIntoView({behavior: 'smooth', block: "nearest", inline: "nearest"});
          }
          else{
            element.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
          }
        }
      });
    },


    onNotesContentView(note) {
      if (!note && !note.id) return;
      this.scrollToNote(note.id)
    },

    removeSingleNote(note) {
      const updatedNotes = this.notes.filter(n => n.id !== note.id);

      const contentAction = {
        ContentID: this.contentData.id,
        DataType: "notes",
        Data: JSON.stringify(updatedNotes)
      };


      this.setUserContentAction(contentAction).then((action) => {
        if (action && action.dataType && action.dataType.toLowerCase() === "notes") {
          this.notes = updatedNotes;
          this.initializeNotes()
          this.updateAction(action)

        }
      }).catch(error => {
        console.error('Error removing note:', error);
      });
    },

    onHighlightContentView(highlight) {
      if (!highlight && !highlight.id) return;
      this.scrollToHighlight(highlight.id)
    },

    removeSingleHighlight(highlight) {
      const updatedHighlights = this.highlightedRanges.filter(h => h.id !== highlight.id);

      const contentAction = {
        ContentID: this.contentData.id,
        DataType: "highlights",
        Data: JSON.stringify(updatedHighlights)
      };


      this.setUserContentAction(contentAction).then((action) => {
        if (action && action.dataType && action.dataType.toLowerCase() === "highlights") {
          this.highlightedRanges = updatedHighlights;
          this.initializeHighlights()
          this.updateAction(action)

        }
      }).catch(error => {
        console.error('Error removing Highlight:', error);
      });
    },
    
    handleInput(event) {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.animationFrameId = requestAnimationFrame(() => {
        this.doSearch();
      });
    },

    doSearch() {
  this.$nextTick(() => {
    if (!this.ePubEditor || !this.ePubEditor.document) {
      return;
    }

    let range = this.ePubEditor.rangy.createRange();
    let searchScopeRange = this.ePubEditor.rangy.createRange();
    searchScopeRange.selectNodeContents(this.ePubEditor.document.getElementById("main-c"));

    let options = {
      caseSensitive: false,
      wholeWordsOnly: false,
      withinRange: searchScopeRange,
      direction: "forward"
    };

    range.selectNodeContents(this.ePubEditor.document.getElementById("main-c"));

    // Clear previous search highlights if necessary
    // this.clearSearchHighlights();

    this.ePubEditor.searchMarker.classAppliers.searchResult.undoToRange(range);

    var searchResults = [];

    let searchTerms = this.contentSearch.split(',').map(term => term.trim()).filter(term => term !== "");

    console.log({searchTerms});

    self = this;
    searchTerms.forEach(term => {
      if (term !== "") {
        const ft = range.findText(term, options);

        console.log({ft});

        while (range.findText(term, options)) {
  
          var searchClassApplier = self.ePubEditor.searchMarker.classAppliers.searchResult;
          searchClassApplier.applyToRange(range);
          searchResults.push(range.startContainer.parentNode);
          range.collapse(false);
        }
      }
    });

    console.log({searchResults});

    this.searchResults = [...searchResults];
    this.searchIndex = -1;

    if (searchResults.length > 0) {
     this.scrollToSearchElement(searchResults[0])
    }
  });
},

scrollToSearchElement(node) {
    if(!node) return;
    
    node.scrollIntoView({behavior: 'smooth', block: "nearest", inline: "nearest"});
},


    focusInput() {
        setTimeout(()=> { this.$refs.contentSearchInput.focus(); }, 200)
    },

   
    previousSearchResult() {
      if (this.searchIndex > 0) {
        this.searchIndex -= 1;
        this.scrollToSearchElement(this.searchResults[this.searchIndex]);
      }
    },
    nextSearchResult() {
      if (this.searchIndex < this.searchResults.length - 1) {
        this.searchIndex += 1;
        this.scrollToSearchElement(this.searchResults[this.searchIndex]);
      }
    },

    closeSearch() {
      this.contentSearch = ''
      this.doSearch()
      this.searchIndex = -1;
      this.isFreetextSearchVisible = false;
      this.$refs.freetextSearchDrpdown.hide(true)
    },

    toggleSearch(){
      this.isFreetextSearchVisible = !this.isFreetextSearchVisible;
      this.focusInput()
    },
    
    onEditControlMenuHide(bvEvent) {
    if(this.isFreetextSearchVisible){
      bvEvent.preventDefault()
    }
    },


    // doSearch() {
    //   this.$nextTick(() => {
    //     if (!this.ePubEditor || !this.ePubEditor.document) {
    //       return;
    //     }

    //     const searchScopeElement = this.ePubEditor.document.getElementById("main-c");
    //     this.clearSearchHighlights();
    //     this.searchResults = [];

    //     const searchTerms = this.contentSearch.split(',').map(term => term.trim()).filter(term => term !== "");

    //     searchTerms.forEach(term => {
    //       if (term !== "") {
    //         this.searchInElement(searchScopeElement, term);
    //       }
    //     });

    //     if (this.searchResults.length > 0) {
    //       this.highlightSearchResults(this.searchResults);
    //       this.scrollToSearchResult(this.searchResults[0].id) 
    //     }
    //   });
    // },
    // searchInElement(element, term) {
    //   const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    //   let node;

    //   while (node = walker.nextNode()) {
    //     let startIndex = 0;
    //     let index;

    //     while ((index = node.nodeValue.indexOf(term, startIndex)) > -1) {
    //       const range = this.ePubEditor.rangy.createRange();
    //       range.setStart(node, index);
    //       range.setEnd(node, index + term.length);

    //       this.searchResults.push({
    //         range,
    //         startIndex: index,
    //         endIndex: index + term.length,
    //         text: term,
    //         id: generateGUID() // Assuming you have a function to generate a unique ID
    //       });

    //       startIndex = index + term.length;
    //     }
    //   }
    // },
    // clearSearchHighlights() {
    //   const highlights = this.ePubEditor.document.querySelectorAll('.searchResult');
    //   highlights.forEach(highlight => {
    //     highlight.classList.remove('searchResult');
    //     highlight.removeAttribute('data-search-id');
    //   });
    // },
    // highlightSearchResults(searchResults) {

    //   searchResults.forEach(result => {
    //     const range = this.ePubEditor.searchMarker.converter.rangeToCharacterRange(
    //       this.ePubEditor.searchMarker.converter.characterRangeToRange(
    //         this.ePubEditor.document.body,
    //         { start: result.startIndex, end: result.endIndex },
    //         this.ePubEditor.document
    //       )
    //     );

    //     let highlightedSearchResult = this.ePubEditor.searchMarker.highlightCharacterRanges("searchResult", [range]);
    //     highlightedSearchResult.forEach(function (h) {
    //       h?.getHighlightElements().forEach(function (e) {
    //         e?.setAttribute("data-search-id", result.id);
    //       });s
    //     });
    //   });
    // },
    // scrollToSearchResult(id) {
    //   this.$nextTick(() => {
    //     const element = this.ePubEditor.document.querySelector(`[data-search-id="${id}"]`);
    //     if (element) {
    //       element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //     }
    //   });
    // },






    // getEncryptedHTML(){
    //   return "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"
    // },

    // getEncryptedHTMLIV(){
    //   return "SHVzc2Fpbkh1c3NhaW5IdQ==";
    // }

  },
  computed: {
    ...mapState("content", ["content", "loading", "contentActions"]),
    ...mapGetters("content", ["getContentActionsFromState"]),
    ...mapState("appState", ["systemParameters"]),

    parsedFreetextAI() {
      try {

        let data = this.systemParameters && this.systemParameters.FreetextAI
          ? JSON.parse(this.systemParameters.FreetextAI)
          : null;
        return data;
      } catch (e) {
        console.error('Error parsing FreetextAIEnabled:', e);
        return null;
      }
    },
    getAIUrl() {

      return this.parsedFreetextAI && typeof this.parsedFreetextAI.url === 'string'
        ? this.parsedFreetextAI.url
        : null;
    },
    isAIHelpEnabled() {
      console.log("AI Object: ", this.parsedFreetextAI)
      return this.parsedFreetextAI &&
        typeof this.parsedFreetextAI.url === 'string' &&
        this.parsedFreetextAI.url.toString().trim().length > 0;
    },

    isCompleted() {
      if (!this.contentData || !this.contentData.id || !this.contentActions || !this.contentActions[this.contentData.id]) {
        return false;
      }

      const contentAction = this.contentActions[this.contentData.id].find(x => x.dataType === 'completionStatus');

      if (!contentAction || !contentAction.data) {
        return false;
      }

      return contentAction.data === 'completed';
    },

    isIpad() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|Macintosh/i.test(userAgent) && ('ontouchend' in document);
    },

    currentRating() {
      if (!this.contentData || !this.contentData.id || !this.contentActions || !this.contentActions[this.contentData.id]) {
        return 'unrated';
      }

      console.log("ContentAction: 1", this.contentActions);
      const contentAction = this.contentActions[this.contentData.id].find(x => x.dataType.toLowerCase() === 'confidence_level');

      if (!contentAction || !contentAction.data) {
        return 'unrated';
      }

      console.log("ContentAction: 2", contentAction);

      return contentAction.data.toLowerCase();
    },

    starClass() {
      return this.currentRating === 'unrated' ? 'fa fa-star-o' : 'fa fa-star';
    },
    starStyle() {
      switch (this.currentRating) {
        case 'high':
          return 'color: green;';
        case 'medium':
          return 'color: yellow;';
        case 'low':
          return 'color: red;';
        default:
          return '';
      }
    },

    truncatedText() {
      return this.selectedNote.text ? this.selectedNote?.text?.substring(0, 150) || 0 : '';
    },
    isOverflowing() {
      return this.selectedNote.text && (this.selectedNote?.text?.length || 0) > 150;
    },

    notesFromState() {
      const actions = this.getContentActionsFromState(this.contentData.id) || [];
      if (!actions || actions.length < 1) { return [] }

      return JSON.parse(this.getContentActionsFromState(this.contentData.id).notes || '[]')
    },

    highlightsFromState() {
      const actions = this.getContentActionsFromState(this.contentData.id) || [];
      if (!actions || actions.length < 1) { return [] }

      return JSON.parse(this.getContentActionsFromState(this.contentData.id).highlights || '[]')
    },

    freetextBookmarkData() {
      const actions = this.getContentActionsFromState(this.contentData.id) || [];
      if (!actions || actions.length < 1) { return [] }
      
      return JSON.parse(this.getContentActionsFromState(this.contentData.id).freetextBookmark || '[]')
    },

    isFreetextBookmarked() {
      return (this.freetextBookmarkData || []).length > 0;
    },

    getSortedNotes() {
      return this.notes.sort((a, b) => a.startIndex - b.startIndex);
    },

    getSortedHighlights() {
    return this.highlightedRanges.sort((a, b) => a.index - b.index);
  },

  selectedHighlightColor(){
    return (this.highlightedRanges.find(x=> x.id === this.highlightedSelectedId)?.color) || 'unset';
  }




  },
  created() {

  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);

    if (this.isQuillSupported) {
      let Inline = Quill.import('blots/inline');

      class NotesBlot extends Inline { }
      NotesBlot.blotName = 'notes';
      NotesBlot.tagName = 'notes';
      NotesBlot.className = 'notes';
      Quill.register(NotesBlot);

      class HighlightBlot extends Inline { }
      HighlightBlot.blotName = 'highlights';
      HighlightBlot.tagName = 'highlights';
      HighlightBlot.className = 'highlights';
      Quill.register(HighlightBlot);

      var options = {
        theme: 'snow',
        pastePlain: true,
        readOnly: true,
        modules: {
          toolbar: false
        }
      };
      var editor = new Quill('#editor', options);
      var delta = editor.clipboard.convert(this.contentData.data);
      editor.setContents(delta);
      var self = this;
      editor.on('selection-change', function (range, oldRange, source) {
        if (range) {
          self.selectedRange = range;
        } else {
          self.selectedRange = null;
        }
      });
      this.quillEditor = editor;
      this.getHighlights();
      this.getNotes();
      
    }
    else {

      if (this.contentData?.data?.startsWith("http")) {
        let self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {

            let encryptedData = JSON.parse(xhttp.responseText);

            let iv = encryptedData.iv;
            let encryptedHtml = encryptedData.encryptedHtml;
            let secret = DataEncrypter.padKey(self.systemParameters.EbookViewerKey, 16);
            let decryptedHtml = DataEncrypter.decrypt(encryptedHtml, secret, iv);
            self.$nextTick(() => {
             self.initializeEPubEditor(self.contentData.data, decryptedHtml);
            });
          }
        };
        xhttp.open("GET", this.contentData.data, true);
        xhttp.send();
      } else {
        this.initializeEPubEditor("", this.contentData.data);
      }
      // let self=this;
      // $(() => {
      //   $(self.ePubEditor.document.body).contextMenu({
      //     selector: "#main-c",
      //     callback: (key, options) => {
      //       if (key == 'highlight') {
      //         this.highlight();
      //       } else if (key == 'note') {
      //         this.takeNotes();
      //       }
      //       let isAiMenu = this.aiAssistantOptions.find(x => x.menu.toLowerCase() == key.toLowerCase());
      //       if (isAiMenu) {
      //         this.getAIHelp(isAiMenu.chatMessage);
      //       }
      //     },
      //     items: {
      //       highlight: {
      //         name: "Make Highlight",
      //         icon: "fas fa-highlighter",
      //         disabled: () => !(this.selectedRange && this.selectedRange.length && this.selectedRange.length > 0),
      //       },
      //       note: {
      //         name: "Take Note",
      //         icon: "fas fa-sticky-note",
      //         disabled: () => !(this.selectedRange && this.selectedRange.length && this.selectedRange.length > 0),
      //       },
      //       ai: {
      //         name: "AI Assistant",
      //         icon: "fas fa-brain",
      //         disabled: () => !(this.selectedRange && this.selectedRange.length && this.selectedRange.length > 0),
      //         items: this.aiMenu()
      //       },
      //     },
      //   });
      // });
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.tab && this.$route.query.tab != this.currentTab) {
        var oldTab = this.currentTab ?? "";
        var newTab = this.$route.query.tab;
        if (oldTab.toLowerCase() == "highlights" && newTab.toLowerCase() == "tableofcontents") {
          this.getHighlights();
          this.getNotes();
        }
        this.currentTab = newTab;
      }
    },
    '$route.query.noteId'(newNoteId) {
      if (newNoteId) {
        this.scrollToNote(newNoteId);
      }
    },
    '$route.query.highlightId'(newHighlightId) {
      if (newHighlightId) {
        this.scrollToHighlight(newHighlightId);
      }
    },
    notes: function () {
      const notesElements = document.querySelectorAll('.notes');
      notesElements.forEach(element => {
        element.addEventListener('click', this.handleNotesClick);
      });
    },
    currentMargin: function (newVal, oldVal) {
      var elements = this.ePubEditor.document.body;
      elements.style.marginLeft = (newVal / 1.5) + "px";
      elements.style.marginRight = (newVal / 1.5) + "px";
      document.getElementById("html-Editor").style.height = this.ePubEditor.getComputedStyle(this.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");
    },
    currentFontSizePercent: function (newVal, oldVal) {
      var elements = this.ePubEditor.document.querySelectorAll('*');
      let self = this;
      // Loop through each element
      elements.forEach(function (element) {
        // Get the computed font size of the element

        var computedStyle = self.ePubEditor.getComputedStyle(element);
        var currentFontSize = parseFloat(computedStyle.getPropertyValue('font-size'));

        if (!element.classList.contains("float-icon") && !element.classList.contains("toolbox-icon")) {

          var orgFontSize = (currentFontSize / (1 + (oldVal / 100)));
          var newFontSize = orgFontSize + (orgFontSize * (newVal / 100));
          element.style.fontSize = newFontSize + 'px';
        } else {

          element.style.fontSize = currentFontSize + 'px';
        }
      });


      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");
    },
    currentFontFamily(newFontFamily, oldVal) {
      const fontClasses = this.fontFamilies.slice(1).map(font => 'font-' + font.value.toLowerCase());

      // Get all elements within the ePubEditor
      const elements = this.ePubEditor.document.querySelectorAll('*');

      // Remove all font classes from each element
      elements.forEach(function(element) {
        element.classList.remove(...fontClasses);
      });

      // Apply the new font class if it's not 'default'
      if (newFontFamily.toLowerCase() !== 'default') {
        const newFontClass = 'font-' + newFontFamily.toLowerCase();

        elements.forEach(function(element) {
          element.classList.add(newFontClass);
        });
      }

      // Update the height of the html-Editor based on new content size
      const editorElement = this.ePubEditor.document.getElementById('main-c');
      document.getElementById('html-Editor').style.height = this.ePubEditor.getComputedStyle(editorElement)?.height ?? (this.ePubEditor.document.body.scrollHeight + 'px');
    },

    currentLineHeightPercent: function (newVal, oldVal) {
      var elements = this.ePubEditor.document.querySelectorAll('*');
      let self = this;

      // Loop through each element
      elements.forEach(function (element) {
        // Get the computed font size of the element
        if (newVal == 0) {
          element.style.lineHeight = "normal";
        } else {
          var computedStyle = self.ePubEditor.getComputedStyle(element);

          var currentLineHeight = computedStyle.getPropertyValue('line-height') == "normal" ? (parseFloat(computedStyle.getPropertyValue('font-size')) * 1.25) : parseFloat(computedStyle.getPropertyValue('line-height'));

          var orgLineHeight = (currentLineHeight / (1 + (oldVal / 100)));
          var newLineHeight = orgLineHeight + (orgLineHeight * (newVal / 100));

          element.style.lineHeight = newLineHeight + 'px';
        }
      });


      document.getElementById("html-Editor").style.height = self.ePubEditor.getComputedStyle(self.ePubEditor.document.getElementById("main-c"))?.height ?? ((self.ePubEditor.document.body.scrollHeight) + "px");
    }
  },
};
function generateGUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );

}
</script>
<style>
.ebook-digital .custom-dark .freeText-main-content {
  background: rgb(51, 51, 51);
}

.ebook-digital .light .freeText-main-content {
  background: #ffffff;
}

.ebook-digital .sepia .freeText-main-content {
  background: rgb(255, 242, 208);
  color: rgb(139, 82, 32);
}

.ebook-digital .freeText-main-content {
  /* max-height: 78vh;
  overflow-y: auto; */
}

.fullscreen-height {
  height: 100vh !important;
  max-height: 100vh !important;
  overflow-y: auto;
}

#mark-completed,
#rating {
  cursor: pointer;
  display: none;
}

#bookmark {
  cursor: pointer;
}

.ebook-digital #mark-completed,
.ebook-digital #rating {
  display: flex;
}

@media (max-width:768px) {

  .chapter-content-left {
    height: calc(100dvh - 210px);
  }

  .ebook-digital .chapter-content-left {
    /* 56 pixels for header and 60 pixels for bottom nav */
    height: calc(100dvh - var(--header-height) - 116px);
  }

  #rating {
    display: flex;
  }
}
</style>
<style scoped>


.ebook-digital .eb-content {
  text-align: -webkit-left;
}

.float-icon {
  text-decoration: none;

}

.float-icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.float-icon input {
  display: block;

}

.float-icon.sepia {
  background: rgb(255, 242, 208);
  color: rgb(139, 82, 32);
}

.float-icon.custom-dark {
  background: #333;
  color: #fff;
}

.note-icon,
.fullscreen-icon {
  font-size: 1.05rem;
}

.bookmark-icon i {
  margin-top: 0.1rem;
}

.float-icon-textalign>>>.btn-lg,
.float-icon-textheight>>>.btn-lg,
.float-icon-lineheight>>>.btn-lg {
  font-size: 1.10rem;
}

.custom-dark {
  background: rgb(51, 51, 51);
  /* color: white; */
}

.light {
  background: #ffffff;
}

.sepia {
  background: rgb(255, 242, 208);
  color: rgb(139, 82, 32);
}

.sidebar-content {
  margin-top: var(--header-height);
  text-align: left;
}

/* Notes take  */
.note-content {
  text-align: left;
  font-size: 15px;
}

#my-sidebar {
  background-color: white;
}

.note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-right: 10px;
}

.fa-trash-alt {
  color: red;
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;
}

/* Notes List  */
#highlights-list,
#notes-list {
  width: 400px;
  background-color: white;
  border-left: 1px solid #ddd;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}


#highlights-list .no-notes-message,
#notes-list .no-notes-message {
  text-align: center;
  color: #999;
  font-size: 16px;
  margin-top: 20px;
}

#highlights-list .close-icon-button,
#notes-list .close-icon-button {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #333;
  margin-right: 10px;
}

#highlights-list .modal-heading,
#notes-list .modal-heading {
  font-size: 20px;
  color: #333;
  text-align: left;
  padding: 20px;
}

#highlights-list .header,
#notes-list .header {
  
  display: flex;
    align-content: flex-start;
    justify-content: space-between;

}

#highlights-list .highlights-container,
#notes-list .notes-container{
  overflow-y: scroll;
  height:90%;
}


#highlights-list .highlight-wrapper,
#notes-list .note-wrapper {
  padding: 10px 20px 10px 20px;
}

#highlights-list .highlight-content,
#notes-list .note-content {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 15px;
  cursor: pointer;
}
/* 
#highlights-list .highlight-content{
  margin-left: 20px;
  margin-right:20px;
} */


#notes-list .note-text {
  font-size: 15px;
  color: #333;
  margin: 0;
  font-style: italic;
  flex: 1;
}

#highlights-list .highlight-text{
  font-size: 15px;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: -webkit-left;
  margin-bottom: 15px;
}

#notes-list .note-icon {
  color: var(--primary-color);
  font-size: 20px;
  margin-right: 10px;
}

#notes-list .comment-text {
  font-size: 15px;
  color: #777;
  margin-bottom: 10px;
}

#highlights-list .note-actions,
#notes-list .note-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
}

#highlights-list .eb-notes-view,
#highlights-list .eb-notes-delete,
#notes-list .eb-notes-view,
#notes-list .eb-notes-delete {
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  font-size: 13px;
}


#highlights-list .eb-notes-delete, #notes-list .eb-notes-delete{
  color: red;
}

#highlights-list .eb-notes-view:hover,
#highlights-list .eb-notes-delete:hover,
#notes-list .eb-notes-view:hover,
#notes-list .eb-notes-delete:hover {
  color: var(--primary-color);
}

.modal-heading {
  margin: 0;
}

.btn-confirm {
  padding: 4px 10px;
  margin-left: 7px;
  border-radius: 7px;
  background-color: var(--color-red);
  color: #fff;
  font-size: 14px;
}

.dialog-body {
  padding: 14px 20px;
  /* Updated padding */
}

.notes-textarea {
  width: 100%;
  min-height: 150px;
  resize: vertical;
  border-radius: 7px;
  font-size: 14px;
}

.character-counter {
  color: #888;
  font-size: 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 7px 14px;
  /* Updated padding */
}



/*.highlights */



.freeText-main-content {
  padding-right: 60px;
}

.ql-editor {
  padding: 0px;
}

.ql-container.ql-snow {
  border: 0px;
}

.ql-editor h2,
.ql-editor h3 {
  margin-bottom: 5px;
}

.ql-spanblock:after {
  content: "<spanblock/>";
}

.spanblock {
  background-color: #F8F8F8;
  border: 1px solid #CCC;
  line-height: 19px;
  padding: 6px 10px;
  border-radius: 3px;
  margin: 15px 0;
}

.ql-container {
  font-family: "Open Sans";
  font-family: "Circular Std", sans-serif !important;
}

/* .floating-menu {
  top: 20px;
  margin-right: 20px;
} */

.ebook-digital #main-FreetextElem {
  display: flex;
  flex-direction: column;
}

.ebook-digital .freeText-main-content {
  flex: 1;
  padding-right: 5px;
  overflow-y: auto;
}

.ebook-digital .floating-menu {
  /* position: fixed; */
  flex-direction: row;
  padding: 12px 2px;
  background-color: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.08);
  height: 56px;
}

.ebook-digital .floating-icons {
  flex-direction: row;
  gap: 3px;
  justify-content: space-evenly;
}

.ebook-digital .float-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}



.ebook-digital .has-floating-menu {
  padding-right: 0px !important;
}


.ebook-digital .freeText-main-content {
  margin-right: 0px !important;
  padding-right: 0px !important;
  margin-top: 0px !important;
}

.ebook-digital .non-full-freetext {
  width: 100%;
  top: 0px;
  right: 0px;
  left: 0px;
}

/* .ebook-digital .content_sidebar_opened .non-full-freetext{
    width: calc(100% - 480px);
    top: 130px;
    right: 0px;
    left: auto;
} */

.ebook-digital .full-freetext {
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
}

.text-size-controls {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50%;
}



@media (max-width: 768px) {

  .ebook-digital .freeText-main-content {
    margin-top: 0px !important;
  }

  .freeText-main-content {
    padding-right: 35px;
  }

  .floating-menu {
    margin-right: 0px;
  }

  .ql-snow .ql-editor h1 {
    font-size: 1.85em;
    margin-bottom: 10px;
  }

  /* .ebook-digital #main-FreetextElem {
    display: flex;
    flex-direction: column;
   
  }

  .ebook-digital .freeText-main-content {
    flex: 1; 
    padding-right: 5px;
    overflow-y: auto;
  }*/

  .ebook-digital .floating-menu {
    position: sticky;
    width: 100%;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 5;
    flex-direction: row;
    padding: 8px 2px;
    background-color: white;
    /* height: 90px; */
  }

  .ebook-digital .floating-icons {
    white-space: nowrap;
    /* flex-wrap: wrap; */
    overflow-x: scroll;
    overflow-y: hidden !important;
  }

  .ebook-digital .float-icon {
    /* flex: 1 1 calc(15% - 10px); */
  }

  /*  .ebook-digital .floating-icons {
    flex-direction: row;
    gap: 10px;
  }

  .ebook-digital .float-icon {
    display: inline-block;
  }

  .ebook-digital .has-floating-menu {
    padding-right: 0px !important;
  }

  
  

 
 */


  .ebook-digital .digital-disabled {
    display: none;
  }

  .ebook-digital .floating-menu {
    max-width: 100%;
    /*overflow-x: auto;*/
  }

  .float-icon {
    margin-right: 5px;
    margin-left: 5px;
    flex: 0 0 32px;
  }

  .float-icon:first-child {
    margin-left: 8px;
  }

  .float-icon.pt-1 {
    padding-top: .125rem !important;
  }

  .ebook-digital .full-freetext {
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
  }

  .ebook-digital .disabled.float-icon {
    display: none;
  }


}



.confidence-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 10px 0;
  padding: 5px;
}

.confidence-btn i {
  margin-right: 20px;
}

.form-check-input {
  display: none;
}


.character-counter {
  text-align: right;
}

.btn-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}

.btn-outline-secondary:hover{
  background-color: transparent;
  color: #6c757d;
}
</style>
<style>

.ebook-digital .dropdown-menu.show{
    position: fixed !important;
    will-change: transform;
    top: 180px !important;
    left: auto !important;
    transform: translate3d(-160px, 9px, 0px);
}

#highlights-list .b-sidebar-body,
#notes-list .b-sidebar-body{
  overflow-y: hidden;
  background: white;
}
.b-sidebar-header {
  background: white;
}

.b-sidebar-header .close {
  display: none;
}

.fa-circle-thin {
  color: gray;
}

.fa-check-circle {
  color: green;
}

.context-menu-icon.context-menu-icon--fa5 i {
  color: var(--primary-color);
}

.freeText-main-content .highlights {
  background: yellow !important;
}

.freeText-main-content .highlights {
  background: yellow !important;
}

.freeText-main-content .notes {
  border-bottom: 1.3px solid var(--primary-color);
  cursor: pointer;

}

/* .notes:after {
  content: "\f040";
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  color: var(--primary-color);
  margin-left: 10px;
  -webkit-font-smoothing: antialiased;
  margin-right: 10px;
} */

.freeText-main-content .highlights {
  background-color: yellow;
  color: black;
}

.freeText-main-content .notes:hover {
  background-color: var(--primary-color);
  color: white;
}

.freeText-main-content .notes:hover {
  background-color: var(--primary-color);
  color: white;
}

.freeText-main-content .notes:hover:after {
  color: white;
}

@media (max-width: 768px) {
  .ebook-digital .dropdown-menu.show{
    left: auto !important;
  }

  .ebook-digital #colorMode .dropdown-menu.show{
    left: 200px !important;
  }

  .ebook-digital #textalign .dropdown-menu.show{
    left: 150px !important;
  }

  .ebook-digital #lineheight .dropdown-menu.show{
    left: 150px !important;
  }

  .ebook-digital #textheight .dropdown-menu.show{
    left: 150px !important;
  }


}
</style>
<style>

.float-icon .btn.dropdown-toggle {
  padding: 0px;
}

.float-icon.show {
  display: flex !important
}

.float-icon .btn-link {
  color: inherit !important;

  .Ai-Sidebar .b-sidebar {
    width: 30%
  }
}

.fa-circle-thin {
  color: gray;
}

.fa-check-circle {
  color: green;
}

</style>

<style scoped>
  #main-FreetextElem {
  display: grid !important;
  grid-template-areas: 
    "header"
    "document";
  grid-template-rows: 56px 1fr; 
  grid-template-columns: 1fr;
  overflow-y: hidden;
  box-sizing: border-box;
}

.floating-menu {
  grid-area: header;
  background-color: #f0f0f0; 
  height: 56px;
}

.freeText-main-content {
  grid-area: document;
  height: calc(100dvh - var(--header-height) - 112px); 
  border: none; 
  overflow-y: auto; 
  box-sizing: border-box;
}

@media (max-width: 768px) {
  #main-FreetextElem {
    height: unset !important;
    width: 100vw !important;
    box-sizing: border-box; 
  }

  .freeText-main-content {
    /* minus ContentHeader, toolbar and bottom navigation since we are using 100dvh = 174 */
    height: calc(100dvh - var(--header-height) - 174px - env(safe-area-inset-bottom)) !important; 
    width: 100vw !important;
    padding-top: env(safe-area-inset-top); 
}


  .floating-menu{
    width: 100vw !important;
  }
}
</style>